import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "inout-page" }
const _hoisted_2 = {
  key: 0,
  class: "save-toast"
}
const _hoisted_3 = { class: "inout-sidebar" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "sidebar-ym-selector" }
const _hoisted_6 = { class: "ym-value" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "sidebar-title-badge" }
const _hoisted_9 = { class: "sidebar-summary" }
const _hoisted_10 = { class: "summary-item carryover" }
const _hoisted_11 = { class: "summary-header" }
const _hoisted_12 = { class: "value prev" }
const _hoisted_13 = { class: "summary-item income" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "summary-item expense" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "summary-header" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "sidebar-filter" }
const _hoisted_20 = { class: "filter-header" }
const _hoisted_21 = { class: "filter-buttons" }
const _hoisted_22 = { class: "sidebar-search-filters" }
const _hoisted_23 = { class: "search-filter-item" }
const _hoisted_24 = { class: "search-input-wrapper" }
const _hoisted_25 = { class: "search-filter-item" }
const _hoisted_26 = { class: "search-input-wrapper" }
const _hoisted_27 = { class: "search-filter-item" }
const _hoisted_28 = { class: "search-input-wrapper" }
const _hoisted_29 = { class: "quick-filters" }
const _hoisted_30 = { class: "sidebar-actions" }
const _hoisted_31 = ["disabled", "title"]
const _hoisted_32 = { class: "inout-main-content" }
const _hoisted_33 = { class: "inout-table-wrapper" }
const _hoisted_34 = {
  key: 0,
  class: "inout-table"
}
const _hoisted_35 = { class: "td-date" }
const _hoisted_36 = { class: "td-gubun" }
const _hoisted_37 = {
  key: 0,
  class: "scode-name"
}
const _hoisted_38 = {
  key: 1,
  class: "scode-missing"
}
const _hoisted_39 = {
  key: 0,
  class: "inline-price-input"
}
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 1,
  class: "price-missing"
}
const _hoisted_42 = {
  key: 1,
  class: "memo-container"
}
const _hoisted_43 = {
  key: 0,
  class: "memo-text"
}
const _hoisted_44 = {
  key: 1,
  class: "memo-missing"
}
const _hoisted_45 = ["title"]
const _hoisted_46 = { class: "action-buttons" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 0,
  class: "learning-info-row"
}
const _hoisted_51 = { colspan: "6" }
const _hoisted_52 = { class: "learning-info-panel" }
const _hoisted_53 = { class: "learning-header" }
const _hoisted_54 = {
  key: 0,
  class: "keyword-add-section"
}
const _hoisted_55 = { class: "keyword-add-form" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "keyword-add-hint" }
const _hoisted_58 = {
  key: 1,
  class: "unlearned-keywords-section"
}
const _hoisted_59 = { class: "unlearned-header" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "unlearned-keywords-list" }
const _hoisted_62 = ["onClick", "disabled", "title"]
const _hoisted_63 = {
  key: 2,
  class: "learning-loading"
}
const _hoisted_64 = {
  key: 0,
  class: "learning-items"
}
const _hoisted_65 = { class: "learning-items-header" }
const _hoisted_66 = { class: "learning-item-edit" }
const _hoisted_67 = ["onKeydown"]
const _hoisted_68 = { class: "learning-item-edit-actions" }
const _hoisted_69 = ["onClick", "disabled"]
const _hoisted_70 = { class: "learning-item-main" }
const _hoisted_71 = { class: "learning-keyword" }
const _hoisted_72 = { class: "learning-scode" }
const _hoisted_73 = { class: "learning-item-meta" }
const _hoisted_74 = { class: "learning-count" }
const _hoisted_75 = {
  key: 0,
  class: "learning-relacc"
}
const _hoisted_76 = { class: "learning-item-actions" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 1,
  class: "learning-empty"
}
const _hoisted_80 = {
  key: 2,
  class: "learning-empty"
}
const _hoisted_81 = {
  key: 1,
  class: "no-data-container filtered"
}
const _hoisted_82 = {
  key: 2,
  class: "no-data-container"
}
const _hoisted_83 = { class: "delete-modal" }
const _hoisted_84 = { class: "delete-modal-header" }
const _hoisted_85 = { class: "delete-icon" }
const _hoisted_86 = { class: "delete-modal-body" }
const _hoisted_87 = {
  key: 0,
  class: "delete-info"
}
const _hoisted_88 = { class: "info-row" }
const _hoisted_89 = { class: "info-value" }
const _hoisted_90 = { class: "info-row" }
const _hoisted_91 = { class: "info-row" }
const _hoisted_92 = { class: "info-value" }
const _hoisted_93 = { class: "delete-modal-footer" }
const _hoisted_94 = ["disabled"]
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { class: "delete-modal delete-all-modal" }
const _hoisted_97 = { class: "delete-modal-header" }
const _hoisted_98 = { class: "delete-icon danger" }
const _hoisted_99 = { class: "delete-modal-body" }
const _hoisted_100 = { class: "delete-message" }
const _hoisted_101 = { class: "count" }
const _hoisted_102 = { class: "delete-summary" }
const _hoisted_103 = { class: "summary-row" }
const _hoisted_104 = { class: "value income" }
const _hoisted_105 = { class: "summary-row" }
const _hoisted_106 = { class: "value expense" }
const _hoisted_107 = { class: "summary-row total" }
const _hoisted_108 = { class: "value" }
const _hoisted_109 = { class: "warning-box" }
const _hoisted_110 = { class: "delete-modal-footer" }
const _hoisted_111 = ["disabled"]
const _hoisted_112 = { key: 1 }
const _hoisted_113 = {
  key: 0,
  class: "learning-modal"
}
const _hoisted_114 = { class: "modal-header learning" }
const _hoisted_115 = { class: "header-icon" }
const _hoisted_116 = { class: "header-text" }
const _hoisted_117 = { class: "modal-body" }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 1 }
const _hoisted_120 = { class: "inference-result-card editable" }
const _hoisted_121 = { class: "result-item" }
const _hoisted_122 = { class: "result-header" }
const _hoisted_123 = { class: "result-value-editable" }
const _hoisted_124 = {
  key: 0,
  class: "result-item"
}
const _hoisted_125 = { class: "result-header" }
const _hoisted_126 = {
  key: 0,
  class: "probability-badge"
}
const _hoisted_127 = { class: "result-value-editable" }
const _hoisted_128 = { class: "rel-acc-option" }
const _hoisted_129 = { class: "rel-acc-name" }
const _hoisted_130 = {
  key: 1,
  class: "rel-acc-distribution"
}
const _hoisted_131 = { class: "distribution-list" }
const _hoisted_132 = { class: "dist-name" }
const _hoisted_133 = { class: "dist-bar-container" }
const _hoisted_134 = { class: "dist-percent" }
const _hoisted_135 = { class: "dist-count" }
const _hoisted_136 = {
  key: 2,
  class: "inference-reason review-needed"
}
const _hoisted_137 = { class: "review-reason-box" }
const _hoisted_138 = { class: "reason-notice" }
const _hoisted_139 = {
  key: 3,
  class: "inference-reason"
}
const _hoisted_140 = { class: "reason-list" }
const _hoisted_141 = { key: 0 }
const _hoisted_142 = { key: 1 }
const _hoisted_143 = { key: 2 }
const _hoisted_144 = { key: 3 }
const _hoisted_145 = { class: "modal-footer" }
const _hoisted_146 = ["disabled"]
const _hoisted_147 = { key: 1 }
const _hoisted_148 = { class: "apply-similar-modal" }
const _hoisted_149 = { class: "modal-header" }
const _hoisted_150 = { class: "modal-body" }
const _hoisted_151 = { class: "similar-info" }
const _hoisted_152 = { class: "similar-message" }
const _hoisted_153 = { class: "modal-footer apply-similar-footer" }
const _hoisted_154 = { class: "range-adjust-modal" }
const _hoisted_155 = { class: "modal-header" }
const _hoisted_156 = { class: "modal-body" }
const _hoisted_157 = { class: "info-section" }
const _hoisted_158 = { class: "info-row" }
const _hoisted_159 = { class: "info-value" }
const _hoisted_160 = { class: "info-row" }
const _hoisted_161 = { class: "info-value" }
const _hoisted_162 = { class: "range-section" }
const _hoisted_163 = { class: "current-range" }
const _hoisted_164 = { class: "range-display" }
const _hoisted_165 = { class: "new-range" }
const _hoisted_166 = { class: "range-inputs" }
const _hoisted_167 = { class: "input-group" }
const _hoisted_168 = ["max"]
const _hoisted_169 = { class: "input-group" }
const _hoisted_170 = ["min"]
const _hoisted_171 = { class: "quick-actions" }
const _hoisted_172 = { class: "notice-box" }
const _hoisted_173 = { class: "modal-footer" }
const _hoisted_174 = { class: "dictionary-manage-modal" }
const _hoisted_175 = { class: "modal-header learning" }
const _hoisted_176 = { class: "header-icon" }
const _hoisted_177 = { class: "modal-body" }
const _hoisted_178 = {
  key: 0,
  class: "dictionary-stats"
}
const _hoisted_179 = { class: "stats-grid" }
const _hoisted_180 = ["onClick"]
const _hoisted_181 = { class: "stat-label" }
const _hoisted_182 = { class: "stat-value" }
const _hoisted_183 = {
  key: 1,
  class: "dict-detail-section"
}
const _hoisted_184 = { class: "detail-header" }
const _hoisted_185 = {
  key: 0,
  class: "detail-loading"
}
const _hoisted_186 = {
  key: 1,
  class: "detail-header-desc"
}
const _hoisted_187 = {
  key: 0,
  class: "dict-search-wrap"
}
const _hoisted_188 = ["placeholder"]
const _hoisted_189 = {
  key: 1,
  class: "desc-text"
}
const _hoisted_190 = {
  key: 2,
  class: "desc-text"
}
const _hoisted_191 = {
  key: 2,
  class: "grouped-dict-container"
}
const _hoisted_192 = { class: "dict-action-header" }
const _hoisted_193 = {
  key: 0,
  class: "grouped-dict-view"
}
const _hoisted_194 = { class: "group-header" }
const _hoisted_195 = { class: "group-title" }
const _hoisted_196 = { class: "account-name" }
const _hoisted_197 = {
  key: 0,
  class: "account-code"
}
const _hoisted_198 = { class: "total-count" }
const _hoisted_199 = ["onClick"]
const _hoisted_200 = { class: "keywords-wrap" }
const _hoisted_201 = ["onClick"]
const _hoisted_202 = { class: "kw-text" }
const _hoisted_203 = { class: "kw-count" }
const _hoisted_204 = ["onClick"]
const _hoisted_205 = {
  key: 1,
  class: "detail-empty"
}
const _hoisted_206 = {
  key: 2,
  class: "detail-empty"
}
const _hoisted_207 = {
  key: 3,
  class: "detail-table-wrap"
}
const _hoisted_208 = { class: "detail-table-header" }
const _hoisted_209 = {
  key: 0,
  class: "detail-table"
}
const _hoisted_210 = ["onClick"]
const _hoisted_211 = { class: "col-account" }
const _hoisted_212 = { class: "col-relacc" }
const _hoisted_213 = { class: "col-count" }
const _hoisted_214 = { class: "count-badge" }
const _hoisted_215 = { class: "col-action" }
const _hoisted_216 = ["onClick"]
const _hoisted_217 = ["onClick"]
const _hoisted_218 = {
  key: 1,
  class: "detail-empty"
}
const _hoisted_219 = {
  key: 4,
  class: "detail-table-wrap"
}
const _hoisted_220 = { class: "detail-table-header" }
const _hoisted_221 = {
  key: 0,
  class: "detail-table"
}
const _hoisted_222 = ["onClick"]
const _hoisted_223 = { class: "col-account" }
const _hoisted_224 = { class: "col-gubun" }
const _hoisted_225 = { class: "col-avg" }
const _hoisted_226 = { class: "col-range" }
const _hoisted_227 = { class: "col-count" }
const _hoisted_228 = { class: "count-badge" }
const _hoisted_229 = { class: "col-action" }
const _hoisted_230 = ["onClick"]
const _hoisted_231 = ["onClick"]
const _hoisted_232 = {
  key: 1,
  class: "detail-empty"
}
const _hoisted_233 = { class: "modal-footer" }
const _hoisted_234 = { class: "keyword-dialog" }
const _hoisted_235 = { class: "dialog-header" }
const _hoisted_236 = { class: "dialog-body" }
const _hoisted_237 = { class: "form-group" }
const _hoisted_238 = {
  key: 1,
  class: "account-display"
}
const _hoisted_239 = { class: "form-group" }
const _hoisted_240 = { class: "dialog-footer" }
const _hoisted_241 = ["disabled"]
const _hoisted_242 = { class: "keyword-dialog" }
const _hoisted_243 = { class: "dialog-header" }
const _hoisted_244 = { class: "dialog-body" }
const _hoisted_245 = { class: "form-group" }
const _hoisted_246 = { class: "form-group" }
const _hoisted_247 = { class: "form-group" }
const _hoisted_248 = { class: "dialog-footer" }
const _hoisted_249 = ["disabled"]
const _hoisted_250 = { class: "keyword-dialog" }
const _hoisted_251 = { class: "dialog-header" }
const _hoisted_252 = { class: "dialog-body" }
const _hoisted_253 = { class: "form-group" }
const _hoisted_254 = { class: "gubun-radio-group" }
const _hoisted_255 = ["disabled"]
const _hoisted_256 = ["disabled"]
const _hoisted_257 = { class: "form-group" }
const _hoisted_258 = { class: "form-row" }
const _hoisted_259 = { class: "form-group half" }
const _hoisted_260 = { class: "form-group half" }
const _hoisted_261 = { class: "form-row" }
const _hoisted_262 = { class: "form-group half" }
const _hoisted_263 = { class: "form-group half" }
const _hoisted_264 = { class: "dialog-footer" }
const _hoisted_265 = ["disabled"]
const _hoisted_266 = { class: "delete-modal" }
const _hoisted_267 = {
  class: "delete-modal-header",
  style: {"background":"linear-gradient(135deg, #059669 0%, #047857 100%)"}
}
const _hoisted_268 = {
  class: "delete-icon",
  style: {"background":"rgba(255,255,255,0.2)"}
}
const _hoisted_269 = { class: "delete-modal-body" }
const _hoisted_270 = { class: "delete-message" }
const _hoisted_271 = { class: "count" }
const _hoisted_272 = { class: "delete-summary" }
const _hoisted_273 = { class: "summary-row" }
const _hoisted_274 = { class: "value income" }
const _hoisted_275 = { class: "summary-row" }
const _hoisted_276 = { class: "value income" }
const _hoisted_277 = { class: "summary-row" }
const _hoisted_278 = { class: "value expense" }
const _hoisted_279 = {
  key: 0,
  class: "summary-row total"
}
const _hoisted_280 = {
  class: "value",
  style: {"color":"#f59e0b"}
}
const _hoisted_281 = {
  class: "warning-box",
  style: {"background":"#eff6ff","border-color":"#3b82f6"}
}
const _hoisted_282 = { class: "delete-message" }
const _hoisted_283 = { class: "count" }
const _hoisted_284 = {
  class: "warning-box",
  style: {"background":"#fef3c7","border-color":"#f59e0b"}
}
const _hoisted_285 = { class: "delete-modal-footer" }
const _hoisted_286 = ["disabled"]
const _hoisted_287 = { key: 1 }

import { ref, computed, onMounted, watch, reactive } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import PgmInoutAuto from '@/components/fna/PgmInoutAuto.vue';

interface InoutData {
  hi_idx?: number;
  m_sisul_code?: string;
  hi_gubun: string;
  hi_scode?: string;
  hi_memo: string;
  hi_price: number;
  hi_inout_date: string;
  hi_funding?: string;
  hi_need_check?: string;
  hi_rel_acc?: string;
  hi_wdate?: string;
  hi_rdate?: string;
  hi_isuse?: string;
}

interface FinanceCode {
  fc_idx: number;
  fc_trcode: string;
  fc_trname: string;
  fc_year: string;
  fc_lcode: string;
  fc_lname: string;
  fc_mcode: string;
  fc_mname: string;
  fc_scode: string;
  fc_sname: string;
  fc_funding: string;
}

interface BalanceSummary {
  scode: string;
  sname: string;
  display: string;
  totalIncome: number;      // 총 수입액
  usedAmount: number;       // 이미 사용된 금액 (지출에서 rel_acc로 연결된)
  availableBalance: number; // 사용 가능 잔액
}

// ============================================
// 자금원 코드 매핑
// ============================================

const STORAGE_KEY = 'inout_current_ym';
interface DictDetailItem {
  idx?: number;
  keyword: string;
  scode: string;
  scodeName?: string;
  count: number;
  relAcc?: string;
  relAccName?: string;
  funding?: string;
  avgAmount?: number;
  minMoney?: number;
  maxMoney?: number;
  gubun?: string;
  sisulCode?: string;
}
interface DictKeyword {
  idx: number;
  keyword: string;
  count: number;
  relAcc?: string;
  relAccName?: string;
}
interface DictGroupedItem {
  scode: string;
  scodeName: string;
  funding?: string;
  relAcc?: string;
  relAccName?: string;
  keywords: DictKeyword[];
  totalCount: number;
}
interface NeedCheckInfo {
  status?: 'OK' | 'NEED_CHECK';
  type: string;
  reason?: string;
  reviewReason?: string;  // ★ 확인필요 이유 (학습 미완료/중복 계정)
  confidence?: string;
  scode?: string;
  funding?: string;
  rel_acc?: string;
  keywords?: string[];
  prediction?: {
    scode: string;
    funding: string;
    rel_acc?: string;
    probability: number;
    source: string;
    matchedKeywords: number;
    totalCount: number;
    keywords?: string[];
    minMoney?: number;
    maxMoney?: number;
    avgMoney?: number;
    moneyMatch?: number;
    moneyMatchText?: string;
    inputPrice?: number;
    relAccDistribution?: Array<{ rel_acc: string; sname: string; count: number; percentage: number }>;
    relAccReason?: string;
  };
  alternatives?: Array<{
    scode: string;
    rel_acc?: string;
    funding?: string;
    probability: number;
    count?: number;
    moneyMatch?: number;
  }>;
  selected_rel_acc?: string;
}

interface InlineLearningItem {
  idx: number;
  sisulCode: string;
  keyword: string;
  scode: string;
  scodeName: string;
  funding?: string;
  relAcc?: string;
  relAccName?: string;
  count: number;
  minMoney: number;
  maxMoney: number;
  scope: string;
}

interface FnaProcessStatus {
  dataYn: boolean;
  confirmedYn: boolean;
  confirmedAt?: string;
  confirmedBy?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InoutPage',
  setup(__props) {

const store = useStore();

// ============================================
// 인터페이스 정의
// ============================================

const FUNDING_MAP: Record<string, string> = {
  '04': '자부담',
  '05': '후원금',
  '06': '수익사업',
  '07': '보조금'
};

// ============================================
// 상태 정의
// ============================================

const isLoading = ref(true);
const isSaving = ref(false);
const isDeleting = ref(false);
const inoutList = ref<InoutData[]>([]);
const carryoverBalance = ref({ income: 0, expense: 0, balance: 0 });  // 누적 이월금
const highlightedIdxList = ref<number[]>([]);  // 하이라이트된 행 목록
const financeCodes = ref<FinanceCode[]>([]);
const financeCodesLoading = ref(false);

// 인라인 수정 관련 상태
const editingRowIdx = ref<number | null>(null);
const inlineEditData = ref<InoutData>({
  hi_gubun: '',
  hi_scode: '',
  hi_memo: '',
  hi_price: 0,
  hi_inout_date: '',
  hi_funding: '',
  hi_rel_acc: ''
});
const originalInlineData = ref<InoutData | null>(null);  // 수정 전 원본 데이터
const isInlineSaving = ref(false);
const showSaveToast = ref(false);

// 날짜 관련 (localStorage에서 복원, 없으면 현재 날짜)
const savedYM = localStorage.getItem(STORAGE_KEY);
const defaultYear = new Date().getFullYear().toString();
const defaultMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');

const currentYear = ref(savedYM ? savedYM.split('-')[0] : defaultYear);
const currentMonth = ref(savedYM ? savedYM.split('-')[1] : defaultMonth);

// 연월 변경 시 localStorage에 저장
watch([currentYear, currentMonth], ([year, month]) => {
  localStorage.setItem(STORAGE_KEY, `${year}-${month}`);
}, { immediate: true });

// 사이드바 위치 (기본: 오른쪽)
const sidebarPosition = ref<'left' | 'right'>('right');

// 월 선택기
const monthPickerRef = ref<HTMLInputElement | null>(null);

// 필터
const filterGubun = ref('all');
const filterNeedCheck = ref(false);
const searchScode = ref('');
const searchMemo = ref('');
const searchPrice = ref('');

// 정렬 (기본: 통장순 - hi_idx 오름차순)
const sortKey = ref<string>('hi_idx');
const sortOrder = ref<'asc' | 'desc'>('asc');

// 모두삭제 다이얼로그
const deleteAllDialogOpen = ref(false);

// 확정하기
const confirmDialogOpen = ref(false);
const isConfirming = ref(false);
const isFillingRelAcc = ref(false);

// 다이얼로그
const deleteDialogOpen = ref(false);
const autoDialogOpen = ref(false);

// 관리자 권한 확인 (시스템 관리자 또는 센터접속 중)
const isAdmin = computed(() => store.getters.isAdmin);
const isImpersonating = computed(() => store.getters.isImpersonating);
const canManageLearning = computed(() => isAdmin.value || isImpersonating.value);

// AI 학습 관리 모달
const dictionaryManageModalOpen = ref(false);
const dictionaryStats = ref<Record<string, { label: string; count: number }> | null>(null);
const selectedDictTable = ref<string | null>(null);
const dictDetailList = ref<DictDetailItem[]>([]);

// 계정별 그룹화된 딕셔너리 목록
const dictGroupedList = ref<DictGroupedItem[]>([]);

// 딕셔너리 검색
const dictSearchQuery = ref('');

// 검색어로 필터링된 딕셔너리 목록
const filteredDictGroupedList = computed(() => {
  if (!dictSearchQuery.value.trim()) {
    return dictGroupedList.value;
  }
  
  const query = dictSearchQuery.value.toLowerCase().trim();
  
  return dictGroupedList.value.filter(group => {
    // 계정명 또는 계정코드에서 검색
    const matchAccount = 
      (group.scodeName && group.scodeName.toLowerCase().includes(query)) ||
      (group.scode && group.scode.toLowerCase().includes(query));
    
    // 키워드에서 검색
    const matchKeyword = group.keywords.some(kw => 
      kw.keyword && kw.keyword.toLowerCase().includes(query)
    );
    
    return matchAccount || matchKeyword;
  });
});

// 키워드 추가/수정 다이얼로그
const keywordDialogOpen = ref(false);
const keywordDialogMode = ref<'add' | 'edit'>('add');
const keywordDialogData = ref({
  idx: 0,
  scode: '',
  scodeName: '',
  keyword: '',
  relAcc: '',
  funding: '',
  isNewAccount: false
});
const isDictDetailLoading = ref(false);

// 상대계정 매핑 추가/수정 다이얼로그
const relmapDialogOpen = ref(false);
const relmapDialogMode = ref<'add' | 'edit'>('add');
const relmapDialogData = ref({
  idx: 0,
  scode: '',
  relAcc: '',
  count: 1
});

// 계정별 통계 추가/수정 다이얼로그
const statsDialogOpen = ref(false);
const statsDialogMode = ref<'add' | 'edit'>('add');
const statsDialogData = ref({
  idx: 0,
  gubun: 'OUT' as 'IN' | 'OUT',
  scode: '',
  minMoney: 0,
  maxMoney: 0,
  avgMoney: 0,
  count: 1
});

const selectedItem = ref<InoutData | null>(null);

// 학습관리 모달 관련
const learningModalOpen = ref(false);
const learningItem = ref<InoutData | null>(null);
const isSavingLearning = ref(false);
const learningFormData = ref({
  scode: '',
  funding: '',
  relAcc: ''
});

// 유사 항목 적용 확인 모달
const applySimilarConfirmOpen = ref(false);
const similarItemsCount = ref(0);
const pendingSaveData = ref<{
  sisulCode: string;
  gubun: string;
  memo: string;
  scode: string;
  funding: string;
  relAcc: string;
  excludeIdx: number;
  price: number;
} | null>(null);

const parsedNeedCheck = computed<NeedCheckInfo | null>(() => {
  if (!learningItem.value?.hi_need_check) return null;
  try {
    return JSON.parse(learningItem.value.hi_need_check);
  } catch {
    return null;
  }
});

// ============================================
// 잔액 계산기 (BalanceCalculator)
// ============================================

const useBalanceCalculator = () => {
  /**
   * 수입 데이터를 scode별로 집계
   */
  const aggregateIncomeByCode = (data: InoutData[]): Map<string, number> => {
    return data
      .filter(item => item.hi_gubun === 'IN' && item.hi_scode)
      .reduce((acc, item) => {
        const scode = item.hi_scode!;
        const currentAmount = acc.get(scode) || 0;
        acc.set(scode, currentAmount + (item.hi_price || 0));
        return acc;
      }, new Map<string, number>());
  };

  /**
   * 지출 데이터에서 상대계정(rel_acc)별 사용 금액 집계
   * @param excludeIdx 제외할 항목 ID (수정 모드에서 현재 항목 제외)
   */
  const aggregateExpenseByRelAcc = (data: InoutData[], excludeIdx?: number): Map<string, number> => {
    return data
      .filter(item => {
        if (item.hi_gubun !== 'OUT' || !item.hi_rel_acc) return false;
        if (excludeIdx && item.hi_idx === excludeIdx) return false;
        return true;
      })
      .reduce((acc, item) => {
        const relAcc = item.hi_rel_acc!;
        const currentAmount = acc.get(relAcc) || 0;
        acc.set(relAcc, currentAmount + (item.hi_price || 0));
        return acc;
      }, new Map<string, number>());
  };

  /**
   * 수입코드별 잔액 정보 계산
   */
  const calculateBalanceSummaries = (
    incomeMap: Map<string, number>,
    expenseMap: Map<string, number>,
    codes: FinanceCode[]
  ): BalanceSummary[] => {
    const summaries: BalanceSummary[] = [];

    incomeMap.forEach((totalIncome, scode) => {
      const usedAmount = expenseMap.get(scode) || 0;
      const availableBalance = totalIncome - usedAmount;

      // 해당 scode의 이름 찾기
      const financeCode = codes.find(
        fc => fc.fc_trcode === 'IN' && fc.fc_scode === scode
      );
      const sname = financeCode?.fc_sname || scode;

      summaries.push({
        scode,
        sname,
        display: sname,
        totalIncome,
        usedAmount,
        availableBalance
      });
    });

    // 잔액 내림차순 정렬
    return summaries.sort((a, b) => b.availableBalance - a.availableBalance);
  };

  return {
    aggregateIncomeByCode,
    aggregateExpenseByRelAcc,
    calculateBalanceSummaries
  };
};

const balanceCalculator = useBalanceCalculator();

// ============================================
// Computed 속성
// ============================================

// 수입 계정코드 리스트
const incomeCodeList = computed(() => {
  return financeCodes.value.filter(fc => fc.fc_trcode === 'IN');
});

// 지출 계정코드 리스트
const expenseCodeList = computed(() => {
  return financeCodes.value.filter(fc => fc.fc_trcode === 'OUT');
});

// 학습 모달용 상대계정 옵션 (현재 등록된 수입 항목에서만 선택 가능)
const learningAvailableRelAcc = computed((): BalanceSummary[] => {
  if (!learningItem.value || learningItem.value.hi_gubun !== 'OUT') return [];
  
  // 수입 집계
  const incomeMap = balanceCalculator.aggregateIncomeByCode(inoutList.value);
  
  // 지출(상대계정) 집계 - 현재 학습 항목 제외
  const excludeIdx = learningItem.value.hi_idx;
  const expenseMap = balanceCalculator.aggregateExpenseByRelAcc(inoutList.value, excludeIdx);
  
  // 잔액 정보 계산
  return balanceCalculator.calculateBalanceSummaries(incomeMap, expenseMap, financeCodes.value);
});

// 필터링된 리스트
const filteredInoutList = computed(() => {
  // 필터링
  let result = inoutList.value.filter(item => {
    // 구분 필터
    if (filterGubun.value !== 'all' && item.hi_gubun !== filterGubun.value) {
      return false;
    }
    // 확인필요 필터: 필수 항목이 없거나 need_check가 있는 항목만 표시
    if (filterNeedCheck.value) {
      if (!needsReview(item)) {
      return false;
    }
    }
    // 계정 검색
    if (searchScode.value) {
      const keyword = searchScode.value.toLowerCase();
      const scodeName = getScodeDisplayName(item.hi_scode, item.hi_gubun);
      const relAccName = item.hi_rel_acc ? getScodeDisplayName(item.hi_rel_acc, 'IN') : '';
      const scodeFields = [item.hi_scode, scodeName, item.hi_rel_acc, relAccName];
      if (!scodeFields.some(field => field?.toLowerCase().includes(keyword))) {
        return false;
      }
    }
    // 적요 검색
    if (searchMemo.value) {
      const keyword = searchMemo.value.toLowerCase();
      if (!item.hi_memo?.toLowerCase().includes(keyword)) {
        return false;
      }
    }
    // 금액 검색
    if (searchPrice.value) {
      const keyword = searchPrice.value.replace(/,/g, '');
      const priceStr = item.hi_price?.toString() || '';
      if (!priceStr.includes(keyword)) {
        return false;
      }
    }
    return true;
  });
  
  // 정렬: 전년도이월금 우선, 그 다음 날짜순 (통장내역 순서)
  result = [...result].sort((a, b) => {
    // 전년도이월금은 항상 맨 위
    const aIsCarryover = a.hi_memo?.includes('전년도이월금') || a.hi_memo?.includes('이월금');
    const bIsCarryover = b.hi_memo?.includes('전년도이월금') || b.hi_memo?.includes('이월금');
    
    if (aIsCarryover && !bIsCarryover) return -1;
    if (!aIsCarryover && bIsCarryover) return 1;
    
    // 사용자 정의 정렬
    let aVal: any = a[sortKey.value as keyof InoutData];
    let bVal: any = b[sortKey.value as keyof InoutData];
    
    // null 처리
    if (aVal === null || aVal === undefined) aVal = '';
    if (bVal === null || bVal === undefined) bVal = '';
    
    // 숫자 비교
    if (sortKey.value === 'hi_price') {
      aVal = Number(aVal) || 0;
      bVal = Number(bVal) || 0;
    }
    
    // 비교
    if (aVal < bVal) return sortOrder.value === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortOrder.value === 'asc' ? 1 : -1;
    return 0;
  });
  
  return result;
});

// 검색 필터 전체 초기화
const clearAllSearch = () => {
  searchScode.value = '';
  searchMemo.value = '';
  searchPrice.value = '';
};

// 확인 필요 여부 판단 (reviewReason 기준)
// - 학습되지 않은 적요 (패턴 기반 추론)
// - 여러 계정이 비슷한 확률로 추론된 경우
const needsReview = (item: InoutData): boolean => {
  // hi_need_check 파싱하여 reviewReason 확인
  if (item.hi_need_check && item.hi_need_check.trim() !== '') {
    try {
      const parsed = JSON.parse(item.hi_need_check);
      // ★ reviewReason이 있으면 확인 필요 (학습 미완료 또는 중복 계정)
      if (parsed.reviewReason) {
        return true;
      }
      // reviewReason이 없으면 OK로 간주
      return false;
    } catch {
      // JSON 파싱 실패 시 확인 필요로 간주
      return true;
    }
  }
  
  // hi_need_check가 없으면 확인 필요 아님
  return false;
};

// 상대계정 없는 지출 여부 (별도 경고용)
const isMissingRelAcc = (item: InoutData): boolean => {
  if (item.hi_gubun !== 'OUT') return false;
  return !item.hi_rel_acc || item.hi_rel_acc.trim() === '';
};

// 확인필요 이유 추출
const getReviewReason = (item: InoutData): string | null => {
  if (!item.hi_need_check) return null;
  try {
    const parsed = JSON.parse(item.hi_need_check);
    return parsed.reviewReason || null;
  } catch {
    return null;
  }
};

// 확인 필요 항목 개수
const needReviewCount = computed(() => {
  return inoutList.value.filter(item => needsReview(item)).length;
});

// 필터로 인해 데이터가 비어있을 때 메시지
const getFilteredEmptyMessage = computed(() => {
  const filters = [];
  
  if (filterNeedCheck.value) {
    filters.push(`'확인필요' 필터`);
  }
  if (filterGubun.value === 'IN') {
    filters.push(`'수입만' 필터`);
  } else if (filterGubun.value === 'OUT') {
    filters.push(`'지출만' 필터`);
  }
  if (searchScode.value) {
    filters.push(`계정코드 검색`);
  }
  if (searchMemo.value) {
    filters.push(`적요 검색`);
  }
  if (searchPrice.value) {
    filters.push(`금액 검색`);
  }
  
  if (filters.length > 0) {
    return `${filters.join(', ')}에 해당하는 항목이 없습니다.`;
  }
  return '필터 조건에 맞는 항목이 없습니다.';
});

// 계정이 없는 항목 개수 (수입/지출 모두)
const missingScodeCount = computed(() => {
  return inoutList.value.filter(item => 
    !item.hi_scode || item.hi_scode.trim() === ''
  ).length;
});

// 모든 항목에 계정이 채워져 있는지 여부
const allScodesFilled = computed(() => missingScodeCount.value === 0);

// 상대계정이 없는 지출 항목 개수
const missingRelAccCount = computed(() => {
  return inoutList.value.filter(item => 
    item.hi_gubun === 'OUT' && 
    item.hi_scode && // 계정코드는 있어야 함
    (!item.hi_rel_acc || item.hi_rel_acc.trim() === '')
  ).length;
});

// 상대계정이 없는 지출 항목 목록 (hi_idx 순)
const missingRelAccItems = computed(() => {
  return inoutList.value
    .filter(item => 
      item.hi_gubun === 'OUT' && 
      item.hi_scode && 
      (!item.hi_rel_acc || item.hi_rel_acc.trim() === '')
    )
    .sort((a, b) => (a.hi_idx || 0) - (b.hi_idx || 0));
});

// 상대계정 없는 지출 총액
const totalMissingRelAccAmount = computed(() => {
  return missingRelAccItems.value.reduce((sum, item) => sum + (item.hi_price || 0), 0);
});

// 사용 가능한 수입 계정 (잔액 계산 포함, hi_idx 순)
const availableIncomeAccounts = computed(() => {
  // 수입 항목을 hi_idx 순으로 정렬
  const incomeItems = inoutList.value
    .filter(item => item.hi_gubun === 'IN' && item.hi_scode)
    .sort((a, b) => (a.hi_idx || 0) - (b.hi_idx || 0));
  
  // scode별 수입 집계
  const incomeByCode: Record<string, { totalIncome: number; sname: string; funding: string | undefined; firstIdx: number }> = {};
  incomeItems.forEach(item => {
    const scode = item.hi_scode!;
    if (!incomeByCode[scode]) {
      incomeByCode[scode] = {
        totalIncome: 0,
        sname: getScodeDisplayName(scode, 'IN'),
        funding: item.hi_funding,
        firstIdx: item.hi_idx || 0
      };
    }
    incomeByCode[scode].totalIncome += item.hi_price || 0;
    // funding이 없으면 업데이트
    if (!incomeByCode[scode].funding && item.hi_funding) {
      incomeByCode[scode].funding = item.hi_funding;
    }
  });
  
  // 이미 사용된 금액 차감 (상대계정이 있는 지출)
  inoutList.value
    .filter(item => item.hi_gubun === 'OUT' && item.hi_rel_acc)
    .forEach(item => {
      const relAcc = item.hi_rel_acc!;
      if (incomeByCode[relAcc]) {
        incomeByCode[relAcc].totalIncome -= item.hi_price || 0;
      }
    });
  
  // 잔액이 있는 것만 반환 (firstIdx 순 정렬)
  return Object.entries(incomeByCode)
    .filter(([, data]) => data.totalIncome > 0)
    .map(([scode, data]) => ({
      scode,
      sname: data.sname,
      funding: data.funding,
      availableBalance: data.totalIncome,
      firstIdx: data.firstIdx
    }))
    .sort((a, b) => a.firstIdx - b.firstIdx);
});

// 총 사용 가능 잔액
const totalAvailableBalance = computed(() => {
  return availableIncomeAccounts.value.reduce((sum, acc) => sum + acc.availableBalance, 0);
});

// 상대계정 선택용 옵션 (잔여금액 포함, 잔액 있는 것 우선 정렬)
const relAccOptionsWithBalance = computed(() => {
  return availableIncomeAccounts.value
    .map(acc => ({
      scode: acc.scode,
      sname: acc.sname,
      availableBalance: acc.availableBalance,
      displayName: `${acc.sname} (${formatNumber(acc.availableBalance)}원)`
    }))
    .sort((a, b) => b.availableBalance - a.availableBalance); // 잔액 높은 순
});

// 통장순 정렬로 설정 (INSERT 순서 = hi_idx 오름차순)
const setSortToChronological = () => {
  sortKey.value = 'hi_idx';
  sortOrder.value = 'asc';
};

// 정렬 토글
const toggleSort = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'desc';
  }
};

// 정렬 아이콘
const getSortIcon = (key: string) => {
  if (sortKey.value !== key) return 'mdi-unfold-more-horizontal';
  return sortOrder.value === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down';
};

// 필터 초기화
const resetFilters = () => {
  filterGubun.value = 'all';
  filterNeedCheck.value = false;
  searchScode.value = '';
  searchMemo.value = '';
  searchPrice.value = '';
};

// ============================================
// AI 학습 관리 기능
// ============================================

// 학습 데이터 통계 조회
const fetchDictionaryStats = async () => {
  try {
    const response = await axios.get('/api/fna/inout/dictionary/stats');
    if (response.data.success) {
      dictionaryStats.value = response.data.data;
    }
  } catch (error) {
    console.error('학습 통계 조회 오류:', error);
    dictionaryStats.value = null;
  }
};

// 학습 관리 모달 열기
const openDictionaryManageModal = async () => {
  dictionaryManageModalOpen.value = true;
  selectedDictTable.value = null;
  dictDetailList.value = [];
  await fetchDictionaryStats();
};

// 딕셔너리 테이블 선택
const selectDictTable = async (tableKey: string) => {
  if (selectedDictTable.value === tableKey) {
    selectedDictTable.value = null;
    dictDetailList.value = [];
    dictGroupedList.value = [];
    return;
  }
  
  selectedDictTable.value = tableKey;
  isDictDetailLoading.value = true;
  dictDetailList.value = [];
  dictGroupedList.value = [];
  dictSearchQuery.value = '';  // 테이블 변경 시에만 검색어 초기화
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    // 수입/지출 딕셔너리는 그룹화된 데이터 조회
    if (tableKey === 'income' || tableKey === 'expense') {
      const response = await axios.get(`/api/fna/inout/dictionary/grouped/${tableKey}`, {
        params: { sisulCode }
      });
      
      if (response.data.success) {
        dictGroupedList.value = response.data.data || [];
      }
    } else {
      // 계정관계맵, 통계는 기존 방식
      const response = await axios.get(`/api/fna/inout/dictionary/detail/${tableKey}`, {
        params: { sisulCode }
      });
      
      if (response.data.success) {
        dictDetailList.value = response.data.data || [];
      }
    }
  } catch (error) {
    console.error('딕셔너리 상세 조회 오류:', error);
    dictDetailList.value = [];
    dictGroupedList.value = [];
  } finally {
    isDictDetailLoading.value = false;
  }
};

// 딕셔너리 데이터 새로고침 (검색어 유지)
const refreshDictData = async () => {
  const tableKey = selectedDictTable.value;
  if (!tableKey) return;
  
  isDictDetailLoading.value = true;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    if (tableKey === 'income' || tableKey === 'expense') {
      const response = await axios.get(`/api/fna/inout/dictionary/grouped/${tableKey}`, {
        params: { sisulCode }
      });
      
      if (response.data.success) {
        dictGroupedList.value = response.data.data || [];
      }
    } else {
      const response = await axios.get(`/api/fna/inout/dictionary/detail/${tableKey}`, {
        params: { sisulCode }
      });
      
      if (response.data.success) {
        dictDetailList.value = response.data.data || [];
      }
    }
  } catch (error) {
    console.error('딕셔너리 새로고침 오류:', error);
  } finally {
    isDictDetailLoading.value = false;
  }
};

// 딕셔너리 테이블 라벨 가져오기
const getDictTableLabel = (tableKey: string): string => {
  const labels: Record<string, string> = {
    income: '수입 딕셔너리',
    expense: '지출 딕셔너리',
    scodeRelmap: '계정관계 맵',
    scodeStats: '계정 통계'
  };
  return labels[tableKey] || tableKey;
};

// 새 계정 추가 다이얼로그 열기
const openNewAccountDialog = () => {
  keywordDialogMode.value = 'add';
  keywordDialogData.value = {
    idx: 0,
    scode: '',
    scodeName: '',
    keyword: '',
    relAcc: '',
    funding: '',
    isNewAccount: true
  };
  keywordDialogOpen.value = true;
};

// 계정 선택 시 이름 업데이트
const onAccountSelect = (scode: string) => {
  if (!scode) {
    keywordDialogData.value.scodeName = '';
    return;
  }
  const codeList = selectedDictTable.value === 'income' ? incomeCodeList.value : expenseCodeList.value;
  const found = codeList.find((c: any) => c.fc_scode === scode);
  keywordDialogData.value.scodeName = found?.fc_sname || '';
};

// 키워드 추가 다이얼로그 열기 (기존 계정에)
const openAddKeywordDialog = (group: DictGroupedItem) => {
  keywordDialogMode.value = 'add';
  keywordDialogData.value = {
    idx: 0,
    scode: group.scode,
    scodeName: group.scodeName,
    keyword: '',
    relAcc: group.relAcc || '',
    funding: group.funding || '',
    isNewAccount: false
  };
  keywordDialogOpen.value = true;
};

// 키워드 수정 다이얼로그 열기
const openEditKeywordDialog = (kw: DictKeyword, group: DictGroupedItem) => {
  keywordDialogMode.value = 'edit';
  keywordDialogData.value = {
    idx: kw.idx,
    scode: group.scode,
    scodeName: group.scodeName,
    keyword: kw.keyword,
    relAcc: kw.relAcc || group.relAcc || '',
    funding: group.funding || '',
    isNewAccount: false
  };
  keywordDialogOpen.value = true;
};

// 키워드 저장 (추가/수정)
const saveKeyword = async () => {
  if (!keywordDialogData.value.keyword?.trim()) return;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    if (keywordDialogMode.value === 'add') {
      // 키워드 추가
      await axios.post('/api/fna/inout/dictionary/keyword', {
        tableKey: selectedDictTable.value,
        sisulCode,
        scode: keywordDialogData.value.scode,
        keyword: keywordDialogData.value.keyword.trim(),
        relAcc: keywordDialogData.value.relAcc,
        funding: keywordDialogData.value.funding
      });
    } else {
      // 키워드 수정
      await axios.put(`/api/fna/inout/dictionary/keyword/${keywordDialogData.value.idx}`, {
        tableKey: selectedDictTable.value,
        keyword: keywordDialogData.value.keyword.trim()
      });
    }
    
    keywordDialogOpen.value = false;
    
    // 데이터 새로고침
    if (selectedDictTable.value) {
      await selectDictTable(selectedDictTable.value);
      // 선택 상태 유지 위해 다시 선택
      selectedDictTable.value = selectedDictTable.value;
    }
    
    // 통계도 갱신
    await fetchDictionaryStats();
    
  } catch (error) {
    console.error('키워드 저장 오류:', error);
    alert('키워드 저장 중 오류가 발생했습니다.');
  }
};

// 키워드 삭제
const deleteKeyword = async (kw: DictKeyword) => {
  if (!confirm(`"${kw.keyword}" 키워드를 삭제하시겠습니까?`)) return;
  
  try {
    const tableKey = selectedDictTable.value;
    await axios.delete(`/api/fna/inout/dictionary/item/${tableKey}/${kw.idx}`);
    
    // 데이터 새로고침 (검색어 유지)
    await refreshDictData();
    
    // 통계 갱신
    await fetchDictionaryStats();
    
  } catch (error) {
    console.error('키워드 삭제 오류:', error);
    alert('키워드 삭제 중 오류가 발생했습니다.');
  }
};

// 상대계정 매핑 다이얼로그 열기
const openRelmapDialog = (mode: 'add' | 'edit', item?: DictDetailItem) => {
  relmapDialogMode.value = mode;
  if (mode === 'edit' && item) {
    relmapDialogData.value = {
      idx: item.idx || 0,
      scode: item.scode || '',
      relAcc: item.relAcc || '',
      count: item.count || 1
    };
  } else {
    relmapDialogData.value = {
      idx: 0,
      scode: '',
      relAcc: '',
      count: 1
    };
  }
  relmapDialogOpen.value = true;
};

// 상대계정 매핑 저장
const saveRelmap = async () => {
  if (!relmapDialogData.value.scode || !relmapDialogData.value.relAcc) return;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    if (relmapDialogMode.value === 'add') {
      await axios.post('/api/fna/inout/dictionary/scodeRelmap', {
        sisulCode,
        scode: relmapDialogData.value.scode,
        relAcc: relmapDialogData.value.relAcc,
        count: relmapDialogData.value.count || 1
      });
    } else {
      await axios.put(`/api/fna/inout/dictionary/scodeRelmap/${relmapDialogData.value.idx}`, {
        scode: relmapDialogData.value.scode,
        relAcc: relmapDialogData.value.relAcc,
        count: relmapDialogData.value.count || 1
      });
    }
    
    relmapDialogOpen.value = false;
    
    // 데이터 새로고침 (검색어 유지)
    await refreshDictData();
    
    // 통계 갱신
    await fetchDictionaryStats();
    
  } catch (error) {
    console.error('상대계정 매핑 저장 오류:', error);
    alert('저장 중 오류가 발생했습니다.');
  }
};

// 계정별 통계 다이얼로그 열기
const openStatsDialog = (mode: 'add' | 'edit', item?: DictDetailItem) => {
  statsDialogMode.value = mode;
  if (mode === 'edit' && item) {
    statsDialogData.value = {
      idx: item.idx || 0,
      gubun: (item.gubun as 'IN' | 'OUT') || 'OUT',
      scode: item.scode || '',
      minMoney: item.minMoney || 0,
      maxMoney: item.maxMoney || 0,
      avgMoney: item.avgAmount || 0,
      count: item.count || 1
    };
  } else {
    statsDialogData.value = {
      idx: 0,
      gubun: 'OUT',
      scode: '',
      minMoney: 0,
      maxMoney: 0,
      avgMoney: 0,
      count: 1
    };
  }
  statsDialogOpen.value = true;
};

// 계정별 통계 저장
const saveStats = async () => {
  if (!statsDialogData.value.scode || !statsDialogData.value.gubun) return;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    if (statsDialogMode.value === 'add') {
      await axios.post('/api/fna/inout/dictionary/scodeStats', {
        sisulCode,
        gubun: statsDialogData.value.gubun,
        scode: statsDialogData.value.scode,
        minMoney: statsDialogData.value.minMoney || 0,
        maxMoney: statsDialogData.value.maxMoney || 0,
        avgMoney: statsDialogData.value.avgMoney || 0,
        count: statsDialogData.value.count || 1
      });
    } else {
      await axios.put(`/api/fna/inout/dictionary/scodeStats/${statsDialogData.value.idx}`, {
        scode: statsDialogData.value.scode,
        minMoney: statsDialogData.value.minMoney || 0,
        maxMoney: statsDialogData.value.maxMoney || 0,
        avgMoney: statsDialogData.value.avgMoney || 0,
        count: statsDialogData.value.count || 1
      });
    }
    
    statsDialogOpen.value = false;
    
    // 데이터 새로고침 (검색어 유지)
    await refreshDictData();
    
    // 통계 갱신
    await fetchDictionaryStats();
    
  } catch (error) {
    console.error('계정별 통계 저장 오류:', error);
    alert('저장 중 오류가 발생했습니다.');
  }
};

// 딕셔너리 항목 삭제
const deleteDictItem = async (item: DictDetailItem) => {
  if (!selectedDictTable.value || !item.idx) {
    alert('삭제할 수 없는 항목입니다.');
    return;
  }
  
  // 항목 유형에 따른 삭제 확인 메시지
  let confirmMsg = '';
  if (selectedDictTable.value === 'scodeRelmap') {
    confirmMsg = `"${item.scodeName || item.scode}" → "${item.relAccName || item.relAcc}" 매핑을 삭제하시겠습니까?`;
  } else if (selectedDictTable.value === 'scodeStats') {
    confirmMsg = `"${item.scodeName || item.scode}" 계정 통계를 삭제하시겠습니까?`;
  } else {
    confirmMsg = `"${item.keyword}" 학습 데이터를 삭제하시겠습니까?`;
  }
  confirmMsg += '\n이 작업은 되돌릴 수 없습니다.';
  
  if (!confirm(confirmMsg)) {
    return;
  }
  
  try {
    const response = await axios.delete(`/api/fna/inout/dictionary/item/${selectedDictTable.value}/${item.idx}`);
    
    if (response.data.success) {
      // 목록에서 제거
      dictDetailList.value = dictDetailList.value.filter(d => d.idx !== item.idx);
      
      // 통계 갱신
      await fetchDictionaryStats();
    } else {
      alert('삭제 실패: ' + response.data.message);
    }
  } catch (error) {
    console.error('딕셔너리 삭제 오류:', error);
    alert('삭제 중 오류가 발생했습니다.');
  }
};

// 요약 데이터
const summaryData = computed(() => {
  const { income, expense } = inoutList.value.reduce(
    (acc, item) => {
      if (item.hi_gubun === 'IN') {
        acc.income += item.hi_price || 0;
      } else {
        acc.expense += item.hi_price || 0;
      }
      return acc;
    },
    { income: 0, expense: 0 }
  );

  return {
    income,
    expense,
    balance: income - expense
  };
});

// 이월금 (해당월 이전까지의 누적 잔액)
const prevMonthBalance = computed(() => {
  return carryoverBalance.value;
});

// 누적잔액 = 이월금 + 당월수입 - 당월지출
const totalBalance = computed(() => {
  return prevMonthBalance.value.balance + summaryData.value.income - summaryData.value.expense;
});

// ============================================
// 유틸리티 함수
// ============================================

const getFundingName = (code: string | undefined): string => {
  if (!code) return '-';
  return FUNDING_MAP[code] || code;
};

const getScodeDisplayName = (scode: string | undefined, gubun: string): string => {
  if (!scode) return '-';
  
  // 먼저 지정된 gubun으로 검색
  let financeCode = financeCodes.value.find(
    fc => fc.fc_trcode === gubun && fc.fc_scode === scode
  );
  
  // 못 찾으면 반대쪽도 검색 (상대계정은 수입 코드이므로)
  if (!financeCode) {
    financeCode = financeCodes.value.find(
      fc => fc.fc_scode === scode
    );
  }
  
  return financeCode ? financeCode.fc_sname : `[${scode}]`;
};

// 상대계정 분포에서 해당 상대계정의 퍼센트 가져오기 (실시간 분포 우선)
const getRelAccPercentage = (relAcc: string | undefined): number => {
  if (!relAcc) return 0;
  
  // 실시간 조회된 분포 우선 사용
  if (realTimeRelAccDistribution.value && realTimeRelAccDistribution.value.length > 0) {
    const dist = realTimeRelAccDistribution.value.find((d: any) => d.rel_acc === relAcc);
    return dist?.percentage || 0;
  }
  
  // 없으면 저장된 분포 사용
  const distribution = parsedNeedCheck.value?.prediction?.relAccDistribution;
  if (!distribution || !Array.isArray(distribution)) return 0;
  
  const dist = distribution.find((d: any) => d.rel_acc === relAcc);
  return dist?.percentage || 0;
};

const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('ko-KR').format(num || 0);
};

const formatDate = (dateStr: string): string => {
  if (!dateStr) return '';
  return dateStr.replace(/-/g, '.');
};

// ============================================
// 금액 입력 핸들러
// ============================================

const handlePriceKeydown = (event: KeyboardEvent) => {
  // 허용 키: 숫자, 백스페이스, 삭제, 화살표, 탭
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
  const isNumber = /^[0-9]$/.test(event.key);
  
  if (!isNumber && !allowedKeys.includes(event.key)) {
    event.preventDefault();
  }
};

// 인라인 금액 입력 키 핸들러 (Enter/Esc 지원)
const handleInlinePriceKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    saveInlineEdit();
    return;
  }
  if (event.key === 'Escape') {
    cancelInlineEdit();
    return;
  }
  
  // 기존 금액 입력 검증
  handlePriceKeydown(event);
};

// ============================================
// 인라인 수정 함수
// ============================================

// 행 클릭 시 인라인 수정 시작
const startInlineEdit = async (item: InoutData, event: Event) => {
  // 확정된 상태면 수정 불가
  if (isConfirmed.value) {
    return;
  }
  
  // 이미 수정 중인 같은 행이면 무시
  if (editingRowIdx.value === item.hi_idx) {
    return;
  }
  
  // 이미 수정 중인 다른 행이 있으면 취소 (저장하지 않음)
  if (editingRowIdx.value && editingRowIdx.value !== item.hi_idx) {
    cancelInlineEdit();
  }
  
  // 새 행 수정 시작
  editingRowIdx.value = item.hi_idx || null;
  inlineEditData.value = { ...item };
  originalInlineData.value = { ...item };
  
  // 학습 정보 조회
  if (item.hi_memo) {
    await fetchLearningInfoByMemo(item.hi_gubun, item.hi_memo);
  }
};

// 인라인 금액 입력 핸들러
const handleInlinePriceInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const rawValue = target.value.replace(/[^0-9]/g, '');
  const numericValue = rawValue ? parseInt(rawValue, 10) : 0;
  inlineEditData.value.hi_price = numericValue;
  target.value = numericValue ? numericValue.toLocaleString() : '';
};

// 인라인 blur 핸들러 (더 이상 자동 저장하지 않음 - 명시적인 저장 버튼 사용)
const handleInlineBlur = () => {
  // blur 시 자동 저장 비활성화 - 사용자가 저장/취소 버튼을 명시적으로 클릭해야 함
  // 다른 행 클릭 시 기존 수정 취소
};

// 인라인 수정 취소
const cancelInlineEdit = () => {
  editingRowIdx.value = null;
  inlineEditData.value = {
    hi_gubun: '',
    hi_scode: '',
    hi_memo: '',
    hi_price: 0,
    hi_inout_date: '',
    hi_funding: '',
    hi_rel_acc: ''
  };
  originalInlineData.value = null;
  inlineLearningInfo.value = [];
  inlineLearningKeywords.value = [];
  // 키워드 편집/추가 상태 초기화
  newKeywordInput.value = '';
  editingKeywordIdx.value = null;
  editingKeywordValue.value = '';
  editingKeywordScode.value = '';
};

// ============================================
// 인라인 수정 - 학습 정보 조회
// ============================================

const inlineLearningInfo = ref<InlineLearningItem[]>([]);
const inlineLearningKeywords = ref<string[]>([]);
const isLoadingLearningInfo = ref(false);

// 적요에서 학습 정보 조회
const fetchLearningInfoByMemo = async (gubun: string, memo: string) => {
  if (!memo || memo.trim().length < 2) {
    inlineLearningInfo.value = [];
    inlineLearningKeywords.value = [];
    return;
  }
  
  isLoadingLearningInfo.value = true;
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    const response = await axios.post('/api/fna/inout/dictionary/search-by-memo', {
      sisulCode,
      gubun,
      memo
    });
    
    if (response.data.success) {
      inlineLearningInfo.value = response.data.data || [];
      inlineLearningKeywords.value = response.data.keywords || [];
    }
  } catch (error) {
    console.error('학습 정보 조회 오류:', error);
    inlineLearningInfo.value = [];
    inlineLearningKeywords.value = [];
  } finally {
    isLoadingLearningInfo.value = false;
  }
};

// 인라인 학습 데이터 삭제
const deleteInlineLearningItem = async (item: InlineLearningItem) => {
  if (!confirm(`"${item.keyword}" 키워드를 삭제하시겠습니까?`)) return;
  
  try {
    const tableKey = inlineEditData.value.hi_gubun === 'IN' ? 'income' : 'expense';
    await axios.delete(`/api/fna/inout/dictionary/item/${tableKey}/${item.idx}`);
    
    // 목록에서 제거
    inlineLearningInfo.value = inlineLearningInfo.value.filter(i => i.idx !== item.idx);
  } catch (error) {
    console.error('학습 데이터 삭제 오류:', error);
    alert('삭제 중 오류가 발생했습니다.');
  }
};

// 학습되지 않은 키워드 목록 (추출된 키워드 중 현재 계정에 매핑되지 않은 것)
const unlearnedKeywords = computed(() => {
  if (!inlineEditData.value.hi_scode) return [];
  
  // 이미 학습된 키워드 목록 (현재 계정에 매핑된 것)
  const learnedKeywordsForCurrentScode = new Set(
    inlineLearningInfo.value
      .filter(item => item.scode === inlineEditData.value.hi_scode)
      .map(item => item.keyword.toLowerCase())
  );
  
  // 추출된 키워드 중 아직 현재 계정에 학습되지 않은 것
  return inlineLearningKeywords.value.filter(
    kw => !learnedKeywordsForCurrentScode.has(kw.toLowerCase())
  );
});

// 키워드 학습 중 상태
const learningKeyword = ref<string | null>(null);

// 개별 키워드를 현재 계정에 학습시키기
const learnKeywordToCurrentAccount = async (keyword: string) => {
  if (!inlineEditData.value.hi_scode || !keyword) return;
  
  learningKeyword.value = keyword;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    const tableKey = inlineEditData.value.hi_gubun === 'IN' ? 'income' : 'expense';
    
    await axios.post('/api/fna/inout/dictionary/keyword', {
      tableKey,
      sisulCode,
      scode: inlineEditData.value.hi_scode,
      keyword: keyword.trim(),
      relAcc: inlineEditData.value.hi_rel_acc || null,
      funding: inlineEditData.value.hi_funding || null
    });
    
    // 성공 시 학습 정보 목록에 추가 (UI 즉시 반영)
    const scodeName = getScodeDisplayName(inlineEditData.value.hi_scode, inlineEditData.value.hi_gubun);
    inlineLearningInfo.value.push({
      idx: Date.now(), // 임시 ID
      sisulCode: store.state.user?.m_sisul_code || '',
      keyword: keyword,
      scode: inlineEditData.value.hi_scode,
      scodeName: scodeName,
      relAcc: inlineEditData.value.hi_rel_acc || undefined,
      relAccName: inlineEditData.value.hi_rel_acc ? getScodeDisplayName(inlineEditData.value.hi_rel_acc, 'IN') : undefined,
      count: 1,
      minMoney: 0,
      maxMoney: 0,
      scope: '지역'
    });
    
  } catch (error) {
    console.error('키워드 학습 오류:', error);
    alert('키워드 학습 중 오류가 발생했습니다.');
  } finally {
    learningKeyword.value = null;
  }
};

// 모든 미학습 키워드를 한 번에 학습
const learnAllUnlearnedKeywords = async () => {
  if (unlearnedKeywords.value.length === 0) return;
  
  for (const keyword of unlearnedKeywords.value) {
    await learnKeywordToCurrentAccount(keyword);
  }
};

// ============================================
// 키워드 CRUD - 직접 추가
// ============================================

const newKeywordInput = ref('');
const isAddingKeyword = ref(false);

const addCustomKeyword = async () => {
  const keyword = newKeywordInput.value.trim();
  if (!keyword || !inlineEditData.value.hi_scode) return;
  
  // 이미 학습된 키워드인지 확인
  const exists = inlineLearningInfo.value.some(
    item => item.keyword.toLowerCase() === keyword.toLowerCase() && 
            item.scode === inlineEditData.value.hi_scode
  );
  
  if (exists) {
    alert('이미 동일한 키워드가 해당 계정에 학습되어 있습니다.');
    return;
  }
  
  isAddingKeyword.value = true;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    const tableKey = inlineEditData.value.hi_gubun === 'IN' ? 'income' : 'expense';
    
    const response = await axios.post('/api/fna/inout/dictionary/keyword', {
      tableKey,
      sisulCode,
      scode: inlineEditData.value.hi_scode,
      keyword: keyword,
      relAcc: inlineEditData.value.hi_rel_acc || null,
      funding: inlineEditData.value.hi_funding || null
    });
    
    // 성공 시 목록에 추가
    const scodeName = getScodeDisplayName(inlineEditData.value.hi_scode, inlineEditData.value.hi_gubun);
    inlineLearningInfo.value.push({
      idx: response.data.insertId || Date.now(),
      sisulCode: sisulCode || '',
      keyword: keyword,
      scode: inlineEditData.value.hi_scode,
      scodeName: scodeName,
      relAcc: inlineEditData.value.hi_rel_acc || undefined,
      relAccName: inlineEditData.value.hi_rel_acc ? getScodeDisplayName(inlineEditData.value.hi_rel_acc, 'IN') : undefined,
      count: 1,
      minMoney: 0,
      maxMoney: 0,
      scope: '지역'
    });
    
    // 입력 필드 초기화
    newKeywordInput.value = '';
    
  } catch (error) {
    console.error('키워드 추가 오류:', error);
    alert('키워드 추가 중 오류가 발생했습니다.');
  } finally {
    isAddingKeyword.value = false;
  }
};

// ============================================
// 키워드 CRUD - 수정
// ============================================

const editingKeywordIdx = ref<number | null>(null);
const editingKeywordValue = ref('');
const editingKeywordScode = ref('');
const isSavingKeyword = ref(false);

const startKeywordEdit = (item: InlineLearningItem) => {
  editingKeywordIdx.value = item.idx;
  editingKeywordValue.value = item.keyword;
  editingKeywordScode.value = item.scode;
};

const cancelKeywordEdit = () => {
  editingKeywordIdx.value = null;
  editingKeywordValue.value = '';
  editingKeywordScode.value = '';
};

const saveKeywordEdit = async (item: InlineLearningItem) => {
  const newKeyword = editingKeywordValue.value.trim();
  const newScode = editingKeywordScode.value;
  
  if (!newKeyword) {
    alert('키워드를 입력해주세요.');
    return;
  }
  
  // 변경사항 없으면 종료
  if (newKeyword === item.keyword && newScode === item.scode) {
    cancelKeywordEdit();
    return;
  }
  
  isSavingKeyword.value = true;
  
  try {
    const tableKey = inlineEditData.value.hi_gubun === 'IN' ? 'income' : 'expense';
    
    // 키워드만 변경된 경우
    if (newScode === item.scode) {
      await axios.put(`/api/fna/inout/dictionary/keyword/${item.idx}`, {
        tableKey,
        keyword: newKeyword
      });
      
      // 로컬 업데이트
      const idx = inlineLearningInfo.value.findIndex(i => i.idx === item.idx);
      if (idx !== -1) {
        inlineLearningInfo.value[idx].keyword = newKeyword;
      }
    } else {
      // 계정이 변경된 경우: 기존 삭제 후 새로 추가
      await axios.delete(`/api/fna/inout/dictionary/item/${tableKey}/${item.idx}`);
      
      const sisulCode = store.state.user?.m_sisul_code;
      const response = await axios.post('/api/fna/inout/dictionary/keyword', {
        tableKey,
        sisulCode,
        scode: newScode,
        keyword: newKeyword,
        relAcc: inlineEditData.value.hi_rel_acc || null,
        funding: inlineEditData.value.hi_funding || null
      });
      
      // 로컬 업데이트
      const idx = inlineLearningInfo.value.findIndex(i => i.idx === item.idx);
      if (idx !== -1) {
        const scodeName = getScodeDisplayName(newScode, inlineEditData.value.hi_gubun);
        inlineLearningInfo.value[idx] = {
          ...inlineLearningInfo.value[idx],
          idx: response.data.insertId || item.idx,
          keyword: newKeyword,
          scode: newScode,
          scodeName: scodeName
        };
      }
    }
    
    cancelKeywordEdit();
    
  } catch (error) {
    console.error('키워드 수정 오류:', error);
    alert('키워드 수정 중 오류가 발생했습니다.');
  } finally {
    isSavingKeyword.value = false;
  }
};

// 인라인 수정 저장
const saveInlineEdit = async () => {
  if (!editingRowIdx.value || isInlineSaving.value) return;
  
  // 변경사항 확인
  const hasChanges = 
    inlineEditData.value.hi_scode !== originalInlineData.value?.hi_scode ||
    inlineEditData.value.hi_price !== originalInlineData.value?.hi_price ||
    inlineEditData.value.hi_memo !== originalInlineData.value?.hi_memo;
  
  if (!hasChanges) {
    editingRowIdx.value = null;
    return;
  }
  
  isInlineSaving.value = true;
  const savedIdx = editingRowIdx.value;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    // 계정 변경 시 학습 수행
    const scodeChanged = inlineEditData.value.hi_scode !== originalInlineData.value?.hi_scode;
    
    // 상대계정 자동 설정 (지출인 경우)
    if (inlineEditData.value.hi_gubun === 'OUT' && !inlineEditData.value.hi_rel_acc) {
      const availableAcc = availableIncomeAccounts.value[0];
      if (availableAcc) {
        inlineEditData.value.hi_rel_acc = availableAcc.scode;
        inlineEditData.value.hi_funding = availableAcc.funding || '06';
      }
    }
    
    // 수입인 경우 자금원천 자동 설정
    if (inlineEditData.value.hi_gubun === 'IN' && inlineEditData.value.hi_scode) {
      const financeCode = financeCodes.value.find(
        fc => fc.fc_scode === inlineEditData.value.hi_scode && fc.fc_trcode === 'IN'
      );
      if (financeCode?.fc_funding) {
        inlineEditData.value.hi_funding = financeCode.fc_funding;
      }
    }
    
    // need_check 상태를 OK로 업데이트
    const updatedNeedCheck = JSON.stringify({
      status: 'OK',
      type: 'inline_edit',
      reason: '인라인 수정 완료',
      modifiedAt: new Date().toISOString()
    });
    
    const payload = {
      ...inlineEditData.value,
      hi_need_check: updatedNeedCheck,
      m_sisul_code: sisulCode
    };
    
    // API 호출
    await axios.put(`/api/fna/inout/${editingRowIdx.value}`, payload);
    
    // 계정 변경 시 학습
    if (scodeChanged && inlineEditData.value.hi_scode) {
      await axios.post('/api/fna/inout/dictionary/learn-single', {
        sisulCode,
        gubun: inlineEditData.value.hi_gubun,
        memo: inlineEditData.value.hi_memo,
        scode: inlineEditData.value.hi_scode,
        funding: inlineEditData.value.hi_funding,
        relAcc: inlineEditData.value.hi_rel_acc,
        price: inlineEditData.value.hi_price
      });
    }
    
    // 로컬 데이터 업데이트
    const localIdx = inoutList.value.findIndex(item => item.hi_idx === savedIdx);
    if (localIdx !== -1) {
      inoutList.value[localIdx] = {
        ...inlineEditData.value,
        hi_need_check: updatedNeedCheck
      };
    }
    
    // 하이라이트 효과 + 토스트 표시
    highlightedIdxList.value = [savedIdx];
    showSaveToast.value = true;
    
    setTimeout(() => {
      highlightedIdxList.value = [];
    }, 2000);
    
    setTimeout(() => {
      showSaveToast.value = false;
    }, 2500);
    
    // 수정 모드 종료
    editingRowIdx.value = null;
    
  } catch (error) {
    console.error('인라인 저장 오류:', error);
    alert('저장 중 오류가 발생했습니다.');
  } finally {
    isInlineSaving.value = false;
  }
};

// ============================================
// 사이드바 위치 토글
// ============================================

const toggleSidebarPosition = () => {
  sidebarPosition.value = sidebarPosition.value === 'left' ? 'right' : 'left';
};

// 월 선택기 열기
const openMonthPicker = () => {
  monthPickerRef.value?.showPicker();
};

// 월 선택기 변경 핸들러
const onMonthPickerChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value; // "2025-12" 형식
  if (value) {
    const [year, month] = value.split('-');
    currentYear.value = year;
    currentMonth.value = month;
  }
};

// ============================================
// 월 변경 함수
// ============================================

const changeMonth = (delta: number) => {
  let year = parseInt(currentYear.value);
  let month = parseInt(currentMonth.value) + delta;
  
  if (month > 12) {
    month = 1;
    year++;
  } else if (month < 1) {
    month = 12;
    year--;
  }
  
  currentYear.value = year.toString();
  currentMonth.value = month.toString().padStart(2, '0');
};

// ============================================
// API 호출 함수
// ============================================

const fetchFinanceCodes = async () => {
  financeCodesLoading.value = true;
  try {
    const response = await axios.get('/api/finance/codes', {
      params: { year: currentYear.value }
    });
    
    if (response.data.success) {
      financeCodes.value = response.data.data || [];
    }
  } catch (error) {
    console.error('재무코드 조회 오류:', error);
    financeCodes.value = [];
  } finally {
    financeCodesLoading.value = false;
  }
};

const fetchInoutData = async () => {
  isLoading.value = true;
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    if (!sisulCode) {
      console.error('시설 코드가 없습니다.');
      return;
    }
    
    const response = await axios.get('/api/fna/inout', {
      params: {
        sisulCode,
        year: currentYear.value,
        month: currentMonth.value
      }
    });
    
    if (response.data.success) {
      inoutList.value = response.data.data || [];
    }
    
    // 프로세스 상태 조회
    await fetchProcessStatus();
  } catch (error) {
    console.error('현금출납부 조회 오류:', error);
    inoutList.value = [];
  } finally {
    isLoading.value = false;
  }
};

// ============================================
// 프로세스 상태 관리
// ============================================

const processStatus = ref<FnaProcessStatus | null>(null);

// 확정 여부
const isConfirmed = computed(() => processStatus.value?.confirmedYn ?? false);

// 날짜시간 포맷
const formatDateTime = (dateStr?: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')} ${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`;
};

// 프로세스 상태 조회
const fetchProcessStatus = async () => {
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    const yearMonth = `${currentYear.value}${currentMonth.value}`;
    if (!sisulCode || !yearMonth) return;
    
    const response = await axios.get(`/api/fna/process/status/${sisulCode}/${yearMonth}`);
    if (response.data.success) {
      processStatus.value = response.data.data;
    }
  } catch (error) {
    console.error('프로세스 상태 조회 오류:', error);
    processStatus.value = null;
  }
};

// 확정해제
const handleUnconfirm = async () => {
  if (!confirm('확정을 해제하시겠습니까? 해제하면 데이터를 다시 수정할 수 있습니다.')) return;
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    const yearMonth = `${currentYear.value}${currentMonth.value}`;
    const response = await axios.post(
      `/api/fna/process/unconfirm/${sisulCode}/${yearMonth}`
    );
    
    if (response.data.success) {
      alert('확정이 해제되었습니다.');
      await fetchProcessStatus();
    }
  } catch (error) {
    console.error('확정해제 오류:', error);
    alert('확정 해제 중 오류가 발생했습니다.');
  }
};

// 자동 업로드 완료 핸들러
const handleAutoUploadSaved = async () => {
  await fetchInoutData();
  await refreshProcessStatus(); // 엑셀 업로드 상태 갱신
};

// 프로세스 상태 갱신 (엑셀 업로드 시 호출)
const refreshProcessStatus = async () => {
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    if (!sisulCode) return;
    
    const yearMonth = `${currentYear.value}${currentMonth.value}`;
    const response = await axios.post(`/api/fna/process/refresh/${sisulCode}/${yearMonth}`);
    
    if (response.data.success) {
      processStatus.value = response.data.data;
    }
  } catch (error) {
    console.error('프로세스 상태 갱신 오류:', error);
  }
};

// 누적 이월금 조회
const fetchCarryoverBalance = async () => {
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    if (!sisulCode) return;
    
    const response = await axios.get('/api/fna/inout/carryover', {
      params: {
        sisulCode,
        year: currentYear.value,
        month: currentMonth.value
      }
    });
    
    if (response.data.success) {
      carryoverBalance.value = response.data.data;
    }
  } catch (error) {
    console.error('누적 이월금 조회 오류:', error);
    carryoverBalance.value = { income: 0, expense: 0, balance: 0 };
  }
};

// ============================================
// 다이얼로그 핸들러
// ============================================

const confirmDelete = (item: InoutData) => {
  selectedItem.value = item;
  deleteDialogOpen.value = true;
};

const deleteInout = async () => {
  if (!selectedItem.value?.hi_idx) return;
  
  isDeleting.value = true;
  try {
    await axios.delete(`/api/fna/inout/${selectedItem.value.hi_idx}`);
    deleteDialogOpen.value = false;
    selectedItem.value = null;
    await fetchInoutData();
  } catch (error) {
    console.error('삭제 오류:', error);
  } finally {
    isDeleting.value = false;
  }
};

// 모두 삭제
const deleteAllItems = async () => {
  if (filteredInoutList.value.length === 0) return;
  
  isDeleting.value = true;
  try {
    // 삭제할 항목들의 ID 목록
    const idsToDelete = filteredInoutList.value.map(item => item.hi_idx).filter(id => id !== undefined);
    
    // 병렬로 삭제 요청 (최대 10개씩 배치 처리)
    const batchSize = 10;
    for (let i = 0; i < idsToDelete.length; i += batchSize) {
      const batch = idsToDelete.slice(i, i + batchSize);
      await Promise.all(batch.map(id => axios.delete(`/api/fna/inout/${id}`)));
    }
    
    deleteAllDialogOpen.value = false;
    resetFilters();
    await fetchInoutData();
  } catch (error) {
    console.error('일괄 삭제 오류:', error);
  } finally {
    isDeleting.value = false;
  }
};

// 확정하기 다이얼로그 열기
const openConfirmDialog = () => {
  confirmDialogOpen.value = true;
};

// 확정하기 실행 (상대계정 자동채우기 + 확정)
const executeConfirm = async () => {
  isConfirming.value = true;
  const updatedIdxList: number[] = [];
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    const userName = store.state.user?.m_name || '시스템';
    
    // 1. 상대계정 없는 항목이 있으면 먼저 자동 채우기
    if (missingRelAccCount.value > 0 && availableIncomeAccounts.value.length > 0) {
      isFillingRelAcc.value = true;
      
      // 잔액 복사본 생성 (로컬에서 차감 관리)
      const balanceMap: Record<string, number> = {};
      const fundingMap: Record<string, string | undefined> = {};
      availableIncomeAccounts.value.forEach(acc => {
        balanceMap[acc.scode] = acc.availableBalance;
        fundingMap[acc.scode] = acc.funding;
      });
      
      // 상대계정 없는 지출 항목들 (hi_idx 순)
      const itemsToUpdate = [...missingRelAccItems.value];
      
      for (const item of itemsToUpdate) {
        const expenseAmount = item.hi_price || 0;
        
        // 잔액이 있는 수입 계정 찾기
        let selectedScode: string | null = null;
        
        // 먼저 금액이 충분한 계정 찾기
        for (const acc of availableIncomeAccounts.value) {
          if (balanceMap[acc.scode] >= expenseAmount) {
            selectedScode = acc.scode;
            break;
          }
        }
        
        // 충분한 계정이 없으면 잔액이 있는 첫 번째 계정 사용
        if (!selectedScode) {
          for (const acc of availableIncomeAccounts.value) {
            if (balanceMap[acc.scode] > 0) {
              selectedScode = acc.scode;
              break;
            }
          }
        }
        
        if (!selectedScode) {
          console.warn(`[확정] 잔액 부족으로 ${item.hi_idx} 항목 건너뜀`);
          continue;
        }
        
        const selectedFunding = fundingMap[selectedScode] || item.hi_funding;
        const updatedNeedCheck = JSON.stringify({ status: 'OK', message: '확정 시 자동 채우기' });
        
        try {
          await axios.put(`/api/fna/inout/${item.hi_idx}`, {
            ...item,
            hi_rel_acc: selectedScode,
            hi_funding: selectedFunding,
            hi_need_check: updatedNeedCheck,
            m_sisul_code: sisulCode
          });
          
          balanceMap[selectedScode] -= expenseAmount;
          
          const localIdx = inoutList.value.findIndex(i => i.hi_idx === item.hi_idx);
          if (localIdx !== -1) {
            inoutList.value[localIdx].hi_rel_acc = selectedScode;
            inoutList.value[localIdx].hi_funding = selectedFunding;
            inoutList.value[localIdx].hi_need_check = updatedNeedCheck;
          }
          
          updatedIdxList.push(item.hi_idx!);
        } catch (err) {
          console.error(`[확정] ${item.hi_idx} 업데이트 실패:`, err);
        }
      }
      
      isFillingRelAcc.value = false;
    }
    
    // 2. 확정 처리
    const yearMonth = `${currentYear.value}${currentMonth.value}`;
    const response = await axios.post(
      `/api/fna/process/confirm/${sisulCode}/${yearMonth}`,
      { userName }
    );
    
    if (response.data.success) {
      // 하이라이트 효과
      if (updatedIdxList.length > 0) {
        highlightedIdxList.value = updatedIdxList;
        setTimeout(() => {
          highlightedIdxList.value = [];
        }, 2000);
      }
      
      confirmDialogOpen.value = false;
      await fetchProcessStatus();
      
      if (updatedIdxList.length > 0) {
        alert(`${updatedIdxList.length}건의 상대계정을 채우고 확정되었습니다.`);
      } else {
        alert('확정되었습니다.');
      }
    }
    
  } catch (error) {
    console.error('확정 처리 오류:', error);
    alert('확정 처리 중 오류가 발생했습니다.');
  } finally {
    isConfirming.value = false;
    isFillingRelAcc.value = false;
  }
};

// ============================================
// 학습관리 기능
// ============================================

const getNeedCheckClass = (needCheck: string | undefined): string => {
  if (!needCheck) return '';
  try {
    const info = JSON.parse(needCheck);
    if (!info.prediction) return 'error';
    if (info.reason?.includes('낮은')) return 'warning';
    return 'info';
  } catch {
    return 'error';
  }
};

// 실시간 상대계정 분포 조회
const realTimeRelAccDistribution = ref<Array<{rel_acc: string; sname: string; count: number; percentage: number}>>([]);

const openLearningModal = async (item: InoutData) => {
  learningItem.value = item;
  learningFormData.value.scode = item.hi_scode || '';
  learningFormData.value.funding = item.hi_funding || '';
  learningFormData.value.relAcc = item.hi_rel_acc || '';
  realTimeRelAccDistribution.value = [];
  learningModalOpen.value = true;
  
  // 지출 항목이고 계정코드가 있으면 실시간으로 상대계정 분포 조회
  if (item.hi_gubun === 'OUT' && item.hi_scode) {
    try {
      const response = await axios.get(`/api/fna/inout/dictionary/rel-acc-distribution/${item.hi_scode}`);
      if (response.data.success && response.data.distribution) {
        realTimeRelAccDistribution.value = response.data.distribution;
      }
    } catch (err) {
      console.warn('[RelAccDist] 조회 실패:', err);
    }
  }
};

// 학습 모달에서 계정 변경 시 상대계정 분포 다시 조회
const onLearningScodeChange = async (newScode: string) => {
  if (!learningItem.value) return;
  
  // 지출 항목이고 계정코드가 있으면 실시간으로 상대계정 분포 조회
  if (learningItem.value.hi_gubun === 'OUT' && newScode) {
    try {
      realTimeRelAccDistribution.value = [];
      const response = await axios.get(`/api/fna/inout/dictionary/rel-acc-distribution/${newScode}`);
      if (response.data.success && response.data.distribution) {
        realTimeRelAccDistribution.value = response.data.distribution;
      }
    } catch (err) {
      console.warn('[RelAccDist] 조회 실패:', err);
    }
  } else {
    realTimeRelAccDistribution.value = [];
  }
};

const getReasonClass = (reason: string): string => {
  if (reason?.includes('실패') || reason?.includes('없음')) return 'error';
  if (reason?.includes('낮은')) return 'warning';
  return 'info';
};

const getReasonIcon = (reason: string): string => {
  if (reason?.includes('실패') || reason?.includes('없음')) return 'mdi-alert-circle';
  if (reason?.includes('낮은')) return 'mdi-alert';
  return 'mdi-information';
};

const getProbabilityClass = (probability: number): string => {
  if (probability >= 80) return 'high';
  if (probability >= 50) return 'medium';
  return 'low';
};

// 상대계정 추론 근거 간소화 (회계 실무자 관점)
const getSimplifiedRelAccReason = (reason: string): string => {
  if (!reason) return '';
  if (reason.includes('학습된 매핑')) {
    const match = reason.match(/→ "([^"]+)"/);
    return match ? `과거 거래에서 "${match[1]}"과 자주 연결됨` : '과거 거래 패턴 기반';
  }
  if (reason.includes('잔액 충분')) return '해당 수입 계정에 잔액 있음';
  if (reason.includes('잔액 부족')) return '잔액이 충분한 수입 계정 선택';
  return reason.replace(/"/g, '').slice(0, 50);
};

// 추론 사유 간소화
const getSimplifiedReason = (reason: string): string => {
  if (!reason) return '';
  if (reason.includes('신뢰도')) return '';
  if (reason.includes('매칭')) return '';
  if (reason.includes('범위')) return '금액이 일반적인 범위와 다름';
  return reason.slice(0, 50);
};

// 사용 가능한 상대계정 목록 (잔액 있는 수입 계정 + 현재 선택된 계정)
const availableRelAccList = computed(() => {
  // 현재 선택된 항목 이전의 수입 항목들 중 잔액이 있는 것
  const currentIdx = learningItem.value?.hi_idx || 0;
  const currentRelAcc = learningItem.value?.hi_rel_acc;
  
  const incomeItems = inoutList.value.filter((item: InoutData) => 
    item.hi_gubun === 'IN' && 
    item.hi_scode && 
    (item.hi_idx || 0) < currentIdx
  );
  
  // scode별로 잔액 계산
  const balanceMap: Record<string, { scode: string; sname: string; balance: number }> = {};
  
  incomeItems.forEach((item: InoutData) => {
    const scode = item.hi_scode;
    if (!scode) return;
    
    if (!balanceMap[scode]) {
      balanceMap[scode] = {
        scode,
        sname: getScodeDisplayName(scode, 'IN'),
        balance: 0
      };
    }
    balanceMap[scode].balance += (item.hi_price || 0);
  });
  
  // 지출로 차감 (현재 항목 제외)
  const expenseItems = inoutList.value.filter((item: InoutData) => 
    item.hi_gubun === 'OUT' && 
    item.hi_rel_acc &&
    (item.hi_idx || 0) < currentIdx &&
    item.hi_idx !== learningItem.value?.hi_idx
  );
  
  expenseItems.forEach((item: InoutData) => {
    const relAcc = item.hi_rel_acc;
    if (relAcc && balanceMap[relAcc]) {
      balanceMap[relAcc].balance -= (item.hi_price || 0);
    }
  });
  
  // 결과 배열 생성
  let result = Object.values(balanceMap)
    .filter(item => item.balance > 0)
    .map(item => ({
      ...item,
      displayName: item.sname
    }))
    .sort((a, b) => b.balance - a.balance);
  
  // 현재 선택된 상대계정이 목록에 없으면 추가
  if (currentRelAcc && !result.find(r => r.scode === currentRelAcc)) {
    const sname = getScodeDisplayName(currentRelAcc, 'IN');
    result.unshift({
      scode: currentRelAcc,
      sname: sname,
      balance: 0,
      displayName: sname
    });
  }
  
  return result;
});

const getMoneyMatchClass = (moneyMatch: number | undefined): string => {
  if (moneyMatch === 2) return 'high';
  if (moneyMatch === 1) return 'medium';
  return 'low';
};

const getMoneyMatchText = (moneyMatch: number | undefined): string => {
  if (moneyMatch === 2) return '정확히 일치';
  if (moneyMatch === 1) return '범위 내';
  return '범위 외';
};

// 금액 범위 시각화 함수
const getRangeBarStyle = (minMoney: number, maxMoney: number, inputPrice: number) => {
  // 전체 범위 계산 (입력값 포함해서)
  const allValues = [minMoney, maxMoney, inputPrice];
  const min = Math.min(...allValues) * 0.8;
  const max = Math.max(...allValues) * 1.2;
  const range = max - min;
  
  if (range === 0) return { left: '10%', width: '80%' };
  
  const left = ((minMoney - min) / range) * 100;
  const width = ((maxMoney - minMoney) / range) * 100;
  
  return {
    left: `${Math.max(5, Math.min(90, left))}%`,
    width: `${Math.max(10, Math.min(85, width))}%`
  };
};

const getInputPriceMarkerStyle = (minMoney: number, maxMoney: number, inputPrice: number) => {
  const allValues = [minMoney, maxMoney, inputPrice];
  const min = Math.min(...allValues) * 0.8;
  const max = Math.max(...allValues) * 1.2;
  const range = max - min;
  
  if (range === 0) return { left: '50%' };
  
  const left = ((inputPrice - min) / range) * 100;
  return { left: `${Math.max(2, Math.min(98, left))}%` };
};

// 분포 위치 계산 (0~100%)
const getDistributionPosition = (minMoney: number, maxMoney: number, value: number): number => {
  if (maxMoney <= minMoney) return 50;
  const position = ((value - minMoney) / (maxMoney - minMoney)) * 100;
  return Math.max(0, Math.min(100, Math.round(position)));
};

// 범위 조정 모달
const rangeAdjustModalOpen = ref(false);
const rangeAdjustData = ref({
  scode: '',
  scodeName: '',
  keyword: '',
  currentMin: 0,
  currentMax: 0,
  newMin: 0,
  newMax: 0,
  gubun: 'IN' as 'IN' | 'OUT'
});

const openRangeAdjustModal = async () => {
  if (!learningItem.value || !parsedNeedCheck.value?.prediction) return;
  
  const prediction = parsedNeedCheck.value.prediction;
  const gubun = learningItem.value.hi_gubun;
  const scode = prediction.scode || learningItem.value.hi_scode || '';
  
  // 현재 범위 설정
  rangeAdjustData.value = {
    scode: scode,
    scodeName: getScodeDisplayName(scode, gubun),
    keyword: parsedNeedCheck.value.keywords?.join(', ') || '',
    currentMin: prediction.minMoney || 0,
    currentMax: prediction.maxMoney || 0,
    newMin: Math.min(prediction.minMoney || 0, learningItem.value.hi_price),
    newMax: Math.max(prediction.maxMoney || 0, learningItem.value.hi_price),
    gubun: gubun as 'IN' | 'OUT'
  };
  
  rangeAdjustModalOpen.value = true;
};

const saveRangeAdjust = async () => {
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    const response = await axios.post('/api/fna/inout/dictionary/adjust-range', {
      sisul_code: sisulCode,
      gubun: rangeAdjustData.value.gubun,
      scode: rangeAdjustData.value.scode,
      keywords: parsedNeedCheck.value?.keywords || [],
      min_money: rangeAdjustData.value.newMin,
      max_money: rangeAdjustData.value.newMax
    });
    
    if (response.data.success) {
      alert('금액 범위가 조정되었습니다.');
      rangeAdjustModalOpen.value = false;
    } else {
      alert('범위 조정 실패: ' + response.data.message);
    }
  } catch (error: any) {
    console.error('범위 조정 오류:', error);
    alert('범위 조정 중 오류가 발생했습니다.');
  }
};

const formatSource = (source: string): string => {
  const sourceMap: Record<string, string> = {
    'dictionary': '시설 딕셔너리',
    'dictionary-global': '전역 딕셔너리',
    'dictionary+relmap': '시설 딕셔너리 + 매핑',
    'dictionary-global+relmap': '전역 딕셔너리 + 매핑'
  };
  return sourceMap[source] || source || '-';
};

const getScodeOptions = (gubun: string) => {
  if (gubun === 'IN') {
    return incomeCodeList.value;
  } else {
    return expenseCodeList.value;
  }
};

const applyAlternative = (alt: { scode: string; rel_acc?: string; funding?: string }) => {
  learningFormData.value.scode = alt.scode;
  if (alt.funding) {
    learningFormData.value.funding = alt.funding;
  }
  if (alt.rel_acc) {
    learningFormData.value.relAcc = alt.rel_acc;
  }
};

// 유사 항목 개수 확인 후 저장
const checkSimilarAndSave = async () => {
  // 인라인 편집과 폼 데이터 모두 확인
  const hasScode = learningItem.value?.hi_scode || learningFormData.value.scode;
  
  if (!learningItem.value?.hi_idx || !hasScode) {
    // 계정코드가 없으면 바로 저장 (유사 항목 적용 안함)
    await saveLearningData(false);
    return;
  }
  
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    // 유사 항목 개수 조회
    const countResult = await axios.post('/api/fna/inout/dictionary/count-similar', {
      sisulCode,
      gubun: learningItem.value.hi_gubun,
      memo: learningItem.value.hi_memo,
      excludeIdx: learningItem.value.hi_idx
    });
    
    if (countResult.data.count > 0) {
      // 유사 항목이 있으면 확인 모달 띄우기
      similarItemsCount.value = countResult.data.count;
      applySimilarConfirmOpen.value = true;
    } else {
      // 유사 항목이 없으면 바로 저장
      await saveLearningData(false);
    }
  } catch (error) {
    console.error('유사 항목 확인 오류:', error);
    // 오류 발생 시 바로 저장 진행
    await saveLearningData(false);
  }
};

const saveLearningData = async (applyToAll: boolean) => {
  if (!learningItem.value?.hi_idx) return;
  
  // 확인 모달 닫기
  applySimilarConfirmOpen.value = false;
  
  isSavingLearning.value = true;
  try {
    const sisulCode = store.state.user?.m_sisul_code;
    
    // 사용자가 수정 완료했으므로 status를 OK로 설정
    const updatedNeedCheck = JSON.stringify({
      status: 'OK',
      type: 'manual',
      reason: '사용자 수정 완료 및 학습',
      modifiedAt: new Date().toISOString()
    });
    
    // learningItem에 직접 바인딩된 값 사용 (인라인 편집 지원)
    const finalScode = learningItem.value.hi_scode || learningFormData.value.scode || null;
    const finalFunding = learningItem.value.hi_funding || learningFormData.value.funding || null;
    const finalRelAcc = learningItem.value.hi_rel_acc || learningFormData.value.relAcc || null;
    
    const payload = {
      ...learningItem.value,
      hi_scode: finalScode,
      hi_funding: finalFunding,
      hi_rel_acc: finalRelAcc,
      hi_need_check: updatedNeedCheck,
      m_sisul_code: sisulCode
    };
    
    // 1. 항목 업데이트
    await axios.put(`/api/fna/inout/${learningItem.value.hi_idx}`, payload);
    
    // 로컬 데이터 업데이트 (스크롤 유지)
    const updatedIdxList: number[] = [learningItem.value.hi_idx];
    
    // 현재 항목 로컬 업데이트
    const currentIdx = inoutList.value.findIndex(item => item.hi_idx === learningItem.value?.hi_idx);
    if (currentIdx !== -1) {
      inoutList.value[currentIdx] = {
        ...inoutList.value[currentIdx],
        hi_scode: finalScode || undefined,
        hi_funding: finalFunding || undefined,
        hi_rel_acc: finalRelAcc || undefined,
        hi_need_check: JSON.stringify({
          status: 'OK',
          type: 'manual',
          reason: '사용자 수정 완료 및 학습',
          modifiedAt: new Date().toISOString()
        })
      };
    }
    
    // 2. 명시적 학습 호출 (계정코드가 있는 경우만)
    // finalScode를 사용하여 인라인 편집과 폼 데이터 모두 지원
    if (finalScode) {
      await axios.post('/api/fna/inout/dictionary/learn-single', {
        sisulCode,
        gubun: learningItem.value.hi_gubun,
        memo: learningItem.value.hi_memo,
        scode: finalScode,
        funding: finalFunding,
        relAcc: finalRelAcc,
        price: learningItem.value.hi_price
      });
      
      // 3. 유사 항목 적용 (사용자가 선택한 경우에만)
      if (applyToAll) {
        const applySimilarResult = await axios.post('/api/fna/inout/dictionary/apply-similar', {
          sisulCode,
          gubun: learningItem.value.hi_gubun,
          memo: learningItem.value.hi_memo,
          scode: finalScode,
          funding: finalFunding,
          relAcc: finalRelAcc,
          excludeIdx: learningItem.value.hi_idx  // 현재 항목 제외
        });
        
        if (applySimilarResult.data.updatedCount > 0) {
          // 업데이트된 항목들의 idx 목록을 받아서 로컬에서도 업데이트
          const updatedItems: number[] = applySimilarResult.data.updatedItems || [];
          for (const updatedIdx of updatedItems) {
            updatedIdxList.push(updatedIdx);
            const idx = inoutList.value.findIndex(item => item.hi_idx === updatedIdx);
            if (idx !== -1) {
              inoutList.value[idx] = {
                ...inoutList.value[idx],
                hi_scode: finalScode || undefined,
                hi_funding: finalFunding || undefined,
                hi_rel_acc: finalRelAcc || undefined,
                hi_need_check: JSON.stringify({
                  status: 'OK',
                  type: 'auto_applied',
                  reason: '학습 내용 자동 적용',
                  appliedAt: new Date().toISOString()
                })
              };
            }
          }
        }
      }
    }
    
    // 하이라이트 효과
    highlightedIdxList.value = updatedIdxList;
    setTimeout(() => {
      highlightedIdxList.value = [];
    }, 2000);
    
    learningModalOpen.value = false;
    learningItem.value = null;
  } catch (error) {
    console.error('학습 저장 오류:', error);
    alert('저장 또는 학습 중 오류가 발생했습니다.');
  } finally {
    isSavingLearning.value = false;
  }
};

// ============================================
// 워처 및 초기화
// ============================================

// 연도/월 변경 시 데이터 다시 조회
watch([currentYear, currentMonth], () => {
  fetchInoutData();
  fetchCarryoverBalance();
  fetchFinanceCodes();
});

// 학습 모달에서 계정 선택 시 자금원천 자동 설정
watch(() => learningFormData.value.scode, (newScode) => {
  if (!newScode || !learningItem.value) return;
  
  // 수입의 경우: financeCodes에서 해당 계정의 funding 가져오기
  if (learningItem.value.hi_gubun === 'IN') {
    const financeCode = financeCodes.value.find(fc => fc.fc_scode === newScode && fc.fc_trcode === 'IN');
    if (financeCode?.fc_funding) {
      learningFormData.value.funding = financeCode.fc_funding;
    }
  }
});

// 지출의 경우: 상대계정(수입 계정) 선택 시 해당 계정의 funding 가져오기
watch(() => learningFormData.value.relAcc, (newRelAcc) => {
  if (!newRelAcc || !learningItem.value) return;
  
  // 지출의 경우: 상대계정(수입 계정)의 fc_funding을 자금원천으로 사용
  if (learningItem.value.hi_gubun === 'OUT') {
    const financeCode = financeCodes.value.find(fc => fc.fc_scode === newRelAcc && fc.fc_trcode === 'IN');
    if (financeCode?.fc_funding) {
      learningFormData.value.funding = financeCode.fc_funding;
    }
  }
});

onMounted(async () => {
  await Promise.all([
    fetchFinanceCodes(),
    fetchInoutData(),
    fetchCarryoverBalance()
  ]);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_LodingComponent = _resolveComponent("LodingComponent")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        (showSaveToast.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                  _createTextVNode("mdi-check-circle", -1)
                ]))]),
                _: 1
              }),
              _cache[82] || (_cache[82] = _createElementVNode("span", null, "저장되었습니다", -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_LodingComponent, {
      "is-visible": isLoading.value,
      text: "현금출납부 데이터 로딩 중..."
    }, null, 8, ["is-visible"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["inout-layout", { 'sidebar-right': sidebarPosition.value === 'right' }])
        }, [
          _createElementVNode("aside", _hoisted_3, [
            _createElementVNode("button", {
              class: "sidebar-position-toggle",
              onClick: toggleSidebarPosition,
              title: sidebarPosition.value === 'left' ? '우측으로 이동' : '좌측으로 이동'
            }, [
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(sidebarPosition.value === 'left' ? 'mdi-arrow-right' : 'mdi-arrow-left'), 1)
                ]),
                _: 1
              })
            ], 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "ym-nav-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMonth(-1)))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                    _createTextVNode("mdi-chevron-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                class: "ym-display",
                onClick: openMonthPicker
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(currentYear.value) + "." + _toDisplayString(currentMonth.value), 1),
                _createElementVNode("input", {
                  type: "month",
                  ref_key: "monthPickerRef",
                  ref: monthPickerRef,
                  value: `${currentYear.value}-${currentMonth.value}`,
                  onChange: onMonthPickerChange,
                  class: "hidden-month-picker"
                }, null, 40, _hoisted_7)
              ]),
              _createElementVNode("button", {
                class: "ym-nav-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeMonth(1)))
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                  _createTextVNode("mdi-book-open-page-variant", -1)
                ]))]),
                _: 1
              }),
              _cache[86] || (_cache[86] = _createElementVNode("span", null, "현금출납부", -1))
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_icon, {
                    size: "14",
                    color: "#6366f1"
                  }, {
                    default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                      _createTextVNode("mdi-arrow-right-bold", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[88] || (_cache[88] = _createElementVNode("span", { class: "label" }, "이월금", -1))
                ]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(formatNumber(prevMonthBalance.value.balance)) + "원", 1)
              ]),
              _cache[92] || (_cache[92] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_13, [
                _cache[89] || (_cache[89] = _createElementVNode("div", { class: "summary-header" }, [
                  _createElementVNode("span", { class: "dot" }),
                  _createElementVNode("span", { class: "label" }, "수입")
                ], -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(formatNumber(summaryData.value.income)) + "원", 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[90] || (_cache[90] = _createElementVNode("div", { class: "summary-header" }, [
                  _createElementVNode("span", { class: "dot" }),
                  _createElementVNode("span", { class: "label" }, "지출")
                ], -1)),
                _createElementVNode("span", _hoisted_16, _toDisplayString(formatNumber(summaryData.value.expense)) + "원", 1)
              ]),
              _cache[93] || (_cache[93] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
              _createElementVNode("div", {
                class: _normalizeClass(["summary-item balance", { warning: totalBalance.value < 0 }])
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_v_icon, {
                    size: "14",
                    color: totalBalance.value >= 0 ? '#10b981' : '#ef4444'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(totalBalance.value >= 0 ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _cache[91] || (_cache[91] = _createElementVNode("span", { class: "label" }, "누적잔액", -1))
                ]),
                _createElementVNode("span", _hoisted_18, _toDisplayString(formatNumber(totalBalance.value)) + "원", 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "#64748b"
                }, {
                  default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                    _createTextVNode("mdi-filter-variant", -1)
                  ]))]),
                  _: 1
                }),
                _cache[95] || (_cache[95] = _createElementVNode("span", null, "구분 필터", -1))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  class: _normalizeClass(["filter-btn", { active: filterGubun.value === 'all' }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (filterGubun.value = 'all'))
                }, " 전체 ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["filter-btn income", { active: filterGubun.value === 'IN' }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (filterGubun.value = 'IN'))
                }, " 수입 ", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["filter-btn expense", { active: filterGubun.value === 'OUT' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (filterGubun.value = 'OUT'))
                }, " 지출 ", 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[97] || (_cache[97] = _createElementVNode("label", { class: "search-label" }, "계정", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "search-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchScode).value = $event)),
                    placeholder: "계정코드..."
                  }, null, 512), [
                    [_vModelText, searchScode.value]
                  ]),
                  (searchScode.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "search-clear",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (searchScode.value = ''))
                      }, [
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[99] || (_cache[99] = _createElementVNode("label", { class: "search-label" }, "적요", -1)),
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "search-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((searchMemo).value = $event)),
                    placeholder: "적요 검색..."
                  }, null, 512), [
                    [_vModelText, searchMemo.value]
                  ]),
                  (searchMemo.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "search-clear",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (searchMemo.value = ''))
                      }, [
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[101] || (_cache[101] = _createElementVNode("label", { class: "search-label" }, "금액", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "search-input",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((searchPrice).value = $event)),
                    placeholder: "금액 검색..."
                  }, null, 512), [
                    [_vModelText, searchPrice.value]
                  ]),
                  (searchPrice.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "search-clear",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (searchPrice.value = ''))
                      }, [
                        _createVNode(_component_v_icon, { size: "12" }, {
                          default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (searchScode.value || searchMemo.value || searchPrice.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "search-clear-all",
                    onClick: clearAllSearch
                  }, [
                    _createVNode(_component_v_icon, { size: "12" }, {
                      default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                        _createTextVNode("mdi-filter-remove", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[103] || (_cache[103] = _createTextVNode(" 초기화 ", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: _normalizeClass(["quick-filter-btn sort-btn", { active: sortKey.value === 'hi_idx' && sortOrder.value === 'asc' }]),
                onClick: setSortToChronological,
                title: "통장내역 순서대로 정렬 (등록 순서)"
              }, [
                _createVNode(_component_v_icon, { size: "12" }, {
                  default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                    _createTextVNode("mdi-sort-ascending", -1)
                  ]))]),
                  _: 1
                }),
                _cache[105] || (_cache[105] = _createElementVNode("span", null, "통장순", -1))
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["quick-filter-item", { active: filterNeedCheck.value }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filterNeedCheck).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, filterNeedCheck.value]
                ]),
                _createVNode(_component_v_icon, {
                  size: "12",
                  color: filterNeedCheck.value ? '#f59e0b' : '#94a3b8'
                }, {
                  default: _withCtx(() => [...(_cache[106] || (_cache[106] = [
                    _createTextVNode("mdi-alert", -1)
                  ]))]),
                  _: 1
                }, 8, ["color"]),
                _createElementVNode("span", null, "확인필요 (" + _toDisplayString(needReviewCount.value) + ")", 1)
              ], 2),
              (filterGubun.value !== 'all' || filterNeedCheck.value || searchScode.value || searchMemo.value || searchPrice.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "quick-filter-reset",
                    onClick: resetFilters
                  }, [
                    _createVNode(_component_v_icon, { size: "12" }, {
                      default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                        _createTextVNode("mdi-refresh", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                class: "action-btn add",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (autoDialogOpen.value = true))
              }, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                }),
                _cache[109] || (_cache[109] = _createTextVNode(" 항목 추가 ", -1))
              ]),
              (!isConfirmed.value && inoutList.value.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "action-btn confirm",
                    onClick: openConfirmDialog,
                    disabled: isFillingRelAcc.value || !allScodesFilled.value,
                    title: !allScodesFilled.value ? `계정이 없는 항목 ${missingScodeCount.value}건이 있습니다. 먼저 모든 계정을 채워주세요.` : '확정하면 수정/삭제가 불가능합니다'
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                        _createTextVNode("mdi-lock-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[111] || (_cache[111] = _createTextVNode(" 확정하기 ", -1))
                  ], 8, _hoisted_31))
                : _createCommentVNode("", true),
              (isConfirmed.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "action-btn unconfirm",
                    onClick: handleUnconfirm
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[112] || (_cache[112] = [
                        _createTextVNode("mdi-lock-open", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[113] || (_cache[113] = _createTextVNode(" 확정해제 ", -1))
                  ]))
                : _createCommentVNode("", true),
              (!isConfirmed.value && filteredInoutList.value.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "action-btn delete-all",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (deleteAllDialogOpen.value = true))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                        _createTextVNode("mdi-delete-sweep", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" 모두삭제 (" + _toDisplayString(filteredInoutList.value.length) + "건) ", 1)
                  ]))
                : _createCommentVNode("", true),
              (canManageLearning.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "action-btn learn",
                    onClick: openDictionaryManageModal
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                        _createTextVNode("mdi-brain", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[116] || (_cache[116] = _createTextVNode(" AI 학습 관리 ", -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("main", _hoisted_32, [
            _createVNode(_component_v_card, { class: "table-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "table-card-text" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      (filteredInoutList.value.length > 0)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_34, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                  class: "th-date sortable",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (toggleSort('hi_inout_date')))
                                }, [
                                  _cache[117] || (_cache[117] = _createTextVNode(" 날짜 ", -1)),
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    class: "sort-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getSortIcon('hi_inout_date')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("th", {
                                  class: "th-gubun sortable",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (toggleSort('hi_gubun')))
                                }, [
                                  _cache[118] || (_cache[118] = _createTextVNode(" 구분 ", -1)),
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    class: "sort-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getSortIcon('hi_gubun')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("th", {
                                  class: "th-scode sortable",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (toggleSort('hi_scode')))
                                }, [
                                  _cache[119] || (_cache[119] = _createTextVNode(" 계정코드 ", -1)),
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    class: "sort-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getSortIcon('hi_scode')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("th", {
                                  class: "th-price sortable",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (toggleSort('hi_price')))
                                }, [
                                  _cache[120] || (_cache[120] = _createTextVNode(" 금액 ", -1)),
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    class: "sort-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getSortIcon('hi_price')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("th", {
                                  class: "th-memo sortable",
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (toggleSort('hi_memo')))
                                }, [
                                  _cache[121] || (_cache[121] = _createTextVNode(" 적요 ", -1)),
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    class: "sort-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getSortIcon('hi_memo')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[122] || (_cache[122] = _createElementVNode("th", { class: "th-actions" }, "기능", -1))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredInoutList.value, (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: item.hi_idx
                                }, [
                                  _createElementVNode("tr", {
                                    class: _normalizeClass({ 
                      'row-highlighted': item.hi_idx && highlightedIdxList.value.includes(item.hi_idx),
                      'row-editing': editingRowIdx.value === item.hi_idx,
                      'row-confirmed': isConfirmed.value
                    })
                                  }, [
                                    _createElementVNode("td", _hoisted_35, _toDisplayString(formatDate(item.hi_inout_date)), 1),
                                    _createElementVNode("td", _hoisted_36, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["gubun-badge", item.hi_gubun === 'IN' ? 'income' : 'expense'])
                                      }, _toDisplayString(item.hi_gubun === 'IN' ? '수입' : '지출'), 3)
                                    ]),
                                    _createElementVNode("td", {
                                      class: "td-scode",
                                      onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      (editingRowIdx.value === item.hi_idx)
                                        ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                                            key: 0,
                                            modelValue: inlineEditData.value.hi_scode,
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((inlineEditData.value.hi_scode) = $event)),
                                            items: item.hi_gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value,
                                            "item-title": "fc_sname",
                                            "item-value": "fc_scode",
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "",
                                            placeholder: "계정 선택",
                                            class: "inline-edit-select",
                                            onKeydown: _withKeys(cancelInlineEdit, ["esc"])
                                          }, null, 8, ["modelValue", "items"]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (item.hi_scode && item.hi_scode.trim())
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(getScodeDisplayName(item.hi_scode, item.hi_gubun)), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "14",
                                                    color: "#f59e0b"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[123] || (_cache[123] = [
                                                      _createTextVNode("mdi-alert", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[124] || (_cache[124] = _createTextVNode(" 미설정 ", -1))
                                                ]))
                                          ], 64))
                                    ]),
                                    _createElementVNode("td", {
                                      class: _normalizeClass(["td-price", [item.hi_gubun === 'IN' ? 'income' : 'expense', { 'missing': !item.hi_price || item.hi_price <= 0 }]]),
                                      onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      (editingRowIdx.value === item.hi_idx)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                            _createElementVNode("input", {
                                              type: "text",
                                              value: formatNumber(inlineEditData.value.hi_price),
                                              onInput: handleInlinePriceInput,
                                              onKeydown: handleInlinePriceKeydown,
                                              class: "inline-price-field"
                                            }, null, 40, _hoisted_40),
                                            _cache[125] || (_cache[125] = _createElementVNode("span", { class: "inline-price-unit" }, "원", -1))
                                          ]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            (item.hi_price && item.hi_price > 0)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(formatNumber(item.hi_price)) + "원 ", 1)
                                                ], 64))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_41, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "14",
                                                    color: "#f59e0b"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                                      _createTextVNode("mdi-alert", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[127] || (_cache[127] = _createTextVNode(" 미설정 ", -1))
                                                ]))
                                          ], 64))
                                    ], 2),
                                    _createElementVNode("td", {
                                      class: "td-memo",
                                      onClick: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      (editingRowIdx.value === item.hi_idx)
                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                            key: 0,
                                            type: "text",
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((inlineEditData.value.hi_memo) = $event)),
                                            onKeydown: [
                                              _withKeys(saveInlineEdit, ["enter"]),
                                              _withKeys(cancelInlineEdit, ["esc"])
                                            ],
                                            class: "inline-memo-input",
                                            placeholder: "적요 입력"
                                          }, null, 544)), [
                                            [_vModelText, inlineEditData.value.hi_memo]
                                          ])
                                        : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                            (item.hi_memo && item.hi_memo.trim())
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(item.hi_memo), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "14",
                                                    color: "#f59e0b"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                                                      _createTextVNode("mdi-alert", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[129] || (_cache[129] = _createTextVNode(" 미설정 ", -1))
                                                ])),
                                            (getReviewReason(item))
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 2,
                                                  class: "review-reason-tag",
                                                  title: getReviewReason(item) || ''
                                                }, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "12",
                                                    color: "#f59e0b"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                                                      _createTextVNode("mdi-alert-circle", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" " + _toDisplayString(getReviewReason(item)), 1)
                                                ], 8, _hoisted_45))
                                              : _createCommentVNode("", true)
                                          ]))
                                    ]),
                                    _createElementVNode("td", {
                                      class: "td-actions",
                                      onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
                                    }, [
                                      _createElementVNode("div", _hoisted_46, [
                                        (editingRowIdx.value === item.hi_idx)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("button", {
                                                class: "action-btn save",
                                                onClick: saveInlineEdit,
                                                disabled: isInlineSaving.value,
                                                title: "저장 (Enter)"
                                              }, [
                                                _createVNode(_component_v_icon, { size: "16" }, {
                                                  default: _withCtx(() => [...(_cache[131] || (_cache[131] = [
                                                    _createTextVNode("mdi-content-save", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ], 8, _hoisted_47),
                                              _createElementVNode("button", {
                                                class: "action-btn cancel",
                                                onClick: cancelInlineEdit,
                                                title: "취소 (Esc)"
                                              }, [
                                                _createVNode(_component_v_icon, { size: "16" }, {
                                                  default: _withCtx(() => [...(_cache[132] || (_cache[132] = [
                                                    _createTextVNode("mdi-close", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ])
                                            ], 64))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              (!isConfirmed.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("button", {
                                                      class: "action-btn edit",
                                                      onClick: ($event: any) => (startInlineEdit(item, $event)),
                                                      title: "수정"
                                                    }, [
                                                      _createVNode(_component_v_icon, { size: "16" }, {
                                                        default: _withCtx(() => [...(_cache[133] || (_cache[133] = [
                                                          _createTextVNode("mdi-pencil", -1)
                                                        ]))]),
                                                        _: 1
                                                      })
                                                    ], 8, _hoisted_48),
                                                    _createElementVNode("button", {
                                                      class: "action-btn delete",
                                                      onClick: ($event: any) => (confirmDelete(item)),
                                                      title: "삭제"
                                                    }, [
                                                      _createVNode(_component_v_icon, { size: "16" }, {
                                                        default: _withCtx(() => [...(_cache[134] || (_cache[134] = [
                                                          _createTextVNode("mdi-delete", -1)
                                                        ]))]),
                                                        _: 1
                                                      })
                                                    ], 8, _hoisted_49)
                                                  ], 64))
                                                : (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 1,
                                                    size: "16",
                                                    color: "#9ca3af",
                                                    title: "확정된 데이터는 수정할 수 없습니다"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[135] || (_cache[135] = [
                                                      _createTextVNode("mdi-lock", -1)
                                                    ]))]),
                                                    _: 1
                                                  }))
                                            ], 64))
                                      ])
                                    ])
                                  ], 2),
                                  (editingRowIdx.value === item.hi_idx)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                                        _createElementVNode("td", _hoisted_51, [
                                          _createElementVNode("div", _hoisted_52, [
                                            _createElementVNode("div", _hoisted_53, [
                                              _createVNode(_component_v_icon, {
                                                size: "16",
                                                color: "#6366f1"
                                              }, {
                                                default: _withCtx(() => [...(_cache[136] || (_cache[136] = [
                                                  _createTextVNode("mdi-brain", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _cache[137] || (_cache[137] = _createElementVNode("span", null, "AI 학습 관리", -1))
                                            ]),
                                            (inlineEditData.value.hi_scode)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                  _createElementVNode("div", _hoisted_55, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((newKeywordInput).value = $event)),
                                                      onKeydown: _withKeys(addCustomKeyword, ["enter"]),
                                                      placeholder: "새 키워드 입력...",
                                                      class: "keyword-input"
                                                    }, null, 544), [
                                                      [_vModelText, newKeywordInput.value]
                                                    ]),
                                                    _createElementVNode("button", {
                                                      class: "keyword-add-btn",
                                                      onClick: addCustomKeyword,
                                                      disabled: !newKeywordInput.value.trim() || isAddingKeyword.value
                                                    }, [
                                                      (isAddingKeyword.value)
                                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                            key: 0,
                                                            indeterminate: "",
                                                            size: "14",
                                                            width: "2"
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                                            key: 1,
                                                            size: "16"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[138] || (_cache[138] = [
                                                              _createTextVNode("mdi-plus", -1)
                                                            ]))]),
                                                            _: 1
                                                          })),
                                                      _cache[139] || (_cache[139] = _createTextVNode(" 추가 ", -1))
                                                    ], 8, _hoisted_56)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_57, [
                                                    _createVNode(_component_v_icon, {
                                                      size: "12",
                                                      color: "#94a3b8"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[140] || (_cache[140] = [
                                                        _createTextVNode("mdi-information-outline", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _createElementVNode("span", null, [
                                                      _cache[141] || (_cache[141] = _createTextVNode("키워드를 입력하면 ", -1)),
                                                      _createElementVNode("strong", null, _toDisplayString(getScodeDisplayName(inlineEditData.value.hi_scode, inlineEditData.value.hi_gubun)), 1),
                                                      _cache[142] || (_cache[142] = _createTextVNode(" 계정에 학습됩니다", -1))
                                                    ])
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (inlineEditData.value.hi_scode && unlearnedKeywords.value.length > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                  _createElementVNode("div", _hoisted_59, [
                                                    _createVNode(_component_v_icon, {
                                                      size: "14",
                                                      color: "#f59e0b"
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[143] || (_cache[143] = [
                                                        _createTextVNode("mdi-lightbulb-on", -1)
                                                      ]))]),
                                                      _: 1
                                                    }),
                                                    _cache[146] || (_cache[146] = _createElementVNode("span", null, "적요에서 추출된 키워드", -1)),
                                                    (unlearnedKeywords.value.length > 1)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          class: "learn-all-btn",
                                                          onClick: learnAllUnlearnedKeywords,
                                                          disabled: learningKeyword.value !== null
                                                        }, [
                                                          _createVNode(_component_v_icon, { size: "14" }, {
                                                            default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                                                              _createTextVNode("mdi-check-all", -1)
                                                            ]))]),
                                                            _: 1
                                                          }),
                                                          _cache[145] || (_cache[145] = _createTextVNode(" 모두 학습 ", -1))
                                                        ], 8, _hoisted_60))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_61, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unlearnedKeywords.value, (kw) => {
                                                      return (_openBlock(), _createElementBlock("button", {
                                                        key: kw,
                                                        class: _normalizeClass(["unlearned-keyword-chip", { 'learning': learningKeyword.value === kw }]),
                                                        onClick: ($event: any) => (learnKeywordToCurrentAccount(kw)),
                                                        disabled: learningKeyword.value !== null,
                                                        title: `'${kw}' 키워드를 현재 계정에 학습`
                                                      }, [
                                                        (learningKeyword.value === kw)
                                                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                              key: 0,
                                                              indeterminate: "",
                                                              size: "12",
                                                              width: "2",
                                                              color: "white"
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_icon, {
                                                              key: 1,
                                                              size: "14"
                                                            }, {
                                                              default: _withCtx(() => [...(_cache[147] || (_cache[147] = [
                                                                _createTextVNode("mdi-plus", -1)
                                                              ]))]),
                                                              _: 1
                                                            })),
                                                        _createElementVNode("span", null, _toDisplayString(kw), 1)
                                                      ], 10, _hoisted_62))
                                                    }), 128))
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (isLoadingLearningInfo.value)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                                  _createVNode(_component_v_progress_circular, {
                                                    indeterminate: "",
                                                    size: "18",
                                                    width: "2",
                                                    color: "primary"
                                                  }),
                                                  _cache[148] || (_cache[148] = _createElementVNode("span", null, "학습 정보 조회 중...", -1))
                                                ]))
                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                  (inlineLearningInfo.value.length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                        _createElementVNode("div", _hoisted_65, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "14",
                                                            color: "#10b981"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[149] || (_cache[149] = [
                                                              _createTextVNode("mdi-check-circle", -1)
                                                            ]))]),
                                                            _: 1
                                                          }),
                                                          _createElementVNode("span", null, "학습된 키워드 (" + _toDisplayString(inlineLearningInfo.value.length) + "개)", 1)
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inlineLearningInfo.value, (lItem) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: lItem.idx,
                                                            class: _normalizeClass(["learning-item", { 
                                'global': lItem.scope === '전역',
                                'current-scode': lItem.scode === inlineEditData.value.hi_scode,
                                'editing': editingKeywordIdx.value === lItem.idx
                              }])
                                                          }, [
                                                            (editingKeywordIdx.value === lItem.idx)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createElementVNode("div", _hoisted_66, [
                                                                    _withDirectives(_createElementVNode("input", {
                                                                      type: "text",
                                                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((editingKeywordValue).value = $event)),
                                                                      onKeydown: [
                                                                        _withKeys(($event: any) => (saveKeywordEdit(lItem)), ["enter"]),
                                                                        _withKeys(cancelKeywordEdit, ["esc"])
                                                                      ],
                                                                      class: "keyword-edit-input",
                                                                      ref_for: true,
                                                                      ref: "keywordEditInput"
                                                                    }, null, 40, _hoisted_67), [
                                                                      [_vModelText, editingKeywordValue.value]
                                                                    ]),
                                                                    _createVNode(_component_v_icon, {
                                                                      size: "12",
                                                                      color: "#94a3b8"
                                                                    }, {
                                                                      default: _withCtx(() => [...(_cache[150] || (_cache[150] = [
                                                                        _createTextVNode("mdi-arrow-right", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createVNode(_component_v_autocomplete, {
                                                                      modelValue: editingKeywordScode.value,
                                                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((editingKeywordScode).value = $event)),
                                                                      items: inlineEditData.value.hi_gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value,
                                                                      "item-title": "fc_sname",
                                                                      "item-value": "fc_scode",
                                                                      variant: "plain",
                                                                      density: "compact",
                                                                      "hide-details": "",
                                                                      placeholder: "계정 선택",
                                                                      class: "keyword-edit-select"
                                                                    }, null, 8, ["modelValue", "items"])
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_68, [
                                                                    _createElementVNode("button", {
                                                                      class: "edit-action-btn save",
                                                                      onClick: ($event: any) => (saveKeywordEdit(lItem)),
                                                                      disabled: isSavingKeyword.value,
                                                                      title: "저장"
                                                                    }, [
                                                                      (isSavingKeyword.value)
                                                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                                            key: 0,
                                                                            indeterminate: "",
                                                                            size: "12",
                                                                            width: "2"
                                                                          }))
                                                                        : (_openBlock(), _createBlock(_component_v_icon, {
                                                                            key: 1,
                                                                            size: "14"
                                                                          }, {
                                                                            default: _withCtx(() => [...(_cache[151] || (_cache[151] = [
                                                                              _createTextVNode("mdi-check", -1)
                                                                            ]))]),
                                                                            _: 1
                                                                          }))
                                                                    ], 8, _hoisted_69),
                                                                    _createElementVNode("button", {
                                                                      class: "edit-action-btn cancel",
                                                                      onClick: cancelKeywordEdit,
                                                                      title: "취소"
                                                                    }, [
                                                                      _createVNode(_component_v_icon, { size: "14" }, {
                                                                        default: _withCtx(() => [...(_cache[152] || (_cache[152] = [
                                                                          _createTextVNode("mdi-close", -1)
                                                                        ]))]),
                                                                        _: 1
                                                                      })
                                                                    ])
                                                                  ])
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createElementVNode("div", _hoisted_70, [
                                                                    _createElementVNode("span", _hoisted_71, _toDisplayString(lItem.keyword), 1),
                                                                    _createVNode(_component_v_icon, {
                                                                      size: "12",
                                                                      color: "#94a3b8"
                                                                    }, {
                                                                      default: _withCtx(() => [...(_cache[153] || (_cache[153] = [
                                                                        _createTextVNode("mdi-arrow-right", -1)
                                                                      ]))]),
                                                                      _: 1
                                                                    }),
                                                                    _createElementVNode("span", _hoisted_72, _toDisplayString(lItem.scodeName), 1),
                                                                    _createElementVNode("span", {
                                                                      class: _normalizeClass(["learning-scope", lItem.scope === '전역' ? 'global' : 'local'])
                                                                    }, _toDisplayString(lItem.scope), 3)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_73, [
                                                                    _createElementVNode("span", _hoisted_74, _toDisplayString(lItem.count) + "회", 1),
                                                                    (lItem.relAccName)
                                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_75, " 상대: " + _toDisplayString(lItem.relAccName), 1))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_76, [
                                                                    _createElementVNode("button", {
                                                                      class: "learning-edit-btn",
                                                                      onClick: ($event: any) => (startKeywordEdit(lItem)),
                                                                      title: "수정"
                                                                    }, [
                                                                      _createVNode(_component_v_icon, { size: "14" }, {
                                                                        default: _withCtx(() => [...(_cache[154] || (_cache[154] = [
                                                                          _createTextVNode("mdi-pencil", -1)
                                                                        ]))]),
                                                                        _: 1
                                                                      })
                                                                    ], 8, _hoisted_77),
                                                                    _createElementVNode("button", {
                                                                      class: "learning-delete-btn",
                                                                      onClick: ($event: any) => (deleteInlineLearningItem(lItem)),
                                                                      title: "삭제"
                                                                    }, [
                                                                      _createVNode(_component_v_icon, { size: "14" }, {
                                                                        default: _withCtx(() => [...(_cache[155] || (_cache[155] = [
                                                                          _createTextVNode("mdi-delete", -1)
                                                                        ]))]),
                                                                        _: 1
                                                                      })
                                                                    ], 8, _hoisted_78)
                                                                  ])
                                                                ], 64))
                                                          ], 2))
                                                        }), 128))
                                                      ]))
                                                    : (!inlineEditData.value.hi_scode)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "18",
                                                            color: "#94a3b8"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[156] || (_cache[156] = [
                                                              _createTextVNode("mdi-information-outline", -1)
                                                            ]))]),
                                                            _: 1
                                                          }),
                                                          _cache[157] || (_cache[157] = _createElementVNode("span", null, "계정을 선택하면 키워드를 학습시킬 수 있습니다.", -1))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                                          _createVNode(_component_v_icon, {
                                                            size: "18",
                                                            color: "#94a3b8"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[158] || (_cache[158] = [
                                                              _createTextVNode("mdi-information-outline", -1)
                                                            ]))]),
                                                            _: 1
                                                          }),
                                                          _cache[159] || (_cache[159] = _createElementVNode("span", null, "학습된 키워드가 없습니다. 위에서 키워드를 추가하세요.", -1))
                                                        ]))
                                                ], 64))
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : (inoutList.value.length > 0 && filteredInoutList.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                              _createVNode(_component_v_icon, {
                                size: "64",
                                color: "#f59e0b"
                              }, {
                                default: _withCtx(() => [...(_cache[160] || (_cache[160] = [
                                  _createTextVNode("mdi-filter-off", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("p", null, _toDisplayString(getFilteredEmptyMessage.value), 1),
                              _createElementVNode("button", {
                                class: "filter-reset-btn",
                                onClick: resetFilters
                              }, [
                                _createVNode(_component_v_icon, { size: "18" }, {
                                  default: _withCtx(() => [...(_cache[161] || (_cache[161] = [
                                    _createTextVNode("mdi-filter-remove", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" 필터 해제하고 전체 보기 (" + _toDisplayString(inoutList.value.length) + "건) ", 1)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                              _createVNode(_component_v_icon, {
                                size: "64",
                                color: "grey-lighten-1"
                              }, {
                                default: _withCtx(() => [...(_cache[162] || (_cache[162] = [
                                  _createTextVNode("mdi-file-document-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[164] || (_cache[164] = _createElementVNode("p", null, "등록된 현금출납 내역이 없습니다.", -1)),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                variant: "tonal",
                                onClick: _cache[28] || (_cache[28] = ($event: any) => (autoDialogOpen.value = true))
                              }, {
                                default: _withCtx(() => [...(_cache[163] || (_cache[163] = [
                                  _createTextVNode(" 첫 항목 추가하기 ", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(PgmInoutAuto, {
      modelValue: autoDialogOpen.value,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((autoDialogOpen).value = $event)),
      "current-year": currentYear.value,
      "current-month": currentMonth.value,
      onSaved: handleAutoUploadSaved
    }, null, 8, ["modelValue", "current-year", "current-month"]),
    _createVNode(_component_v_dialog, {
      modelValue: deleteDialogOpen.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((deleteDialogOpen).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[165] || (_cache[165] = [
                  _createTextVNode("mdi-alert", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[166] || (_cache[166] = _createElementVNode("h3", null, "삭제 확인", -1)),
            _cache[167] || (_cache[167] = _createElementVNode("p", null, "이 작업은 되돌릴 수 없습니다", -1))
          ]),
          _createElementVNode("div", _hoisted_86, [
            _cache[171] || (_cache[171] = _createElementVNode("p", { class: "delete-message" }, "선택한 현금출납 항목을 삭제하시겠습니까?", -1)),
            (selectedItem.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _cache[168] || (_cache[168] = _createElementVNode("span", { class: "info-label" }, "날짜", -1)),
                    _createElementVNode("span", _hoisted_89, _toDisplayString(formatDate(selectedItem.value.hi_inout_date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _cache[169] || (_cache[169] = _createElementVNode("span", { class: "info-label" }, "구분", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["info-value", selectedItem.value.hi_gubun === 'IN' ? 'income' : 'expense'])
                    }, _toDisplayString(selectedItem.value.hi_gubun === 'IN' ? '수입' : '지출'), 3)
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _cache[170] || (_cache[170] = _createElementVNode("span", { class: "info-label" }, "금액", -1)),
                    _createElementVNode("span", _hoisted_92, _toDisplayString(formatNumber(selectedItem.value.hi_price)) + "원", 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (deleteDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-delete",
              onClick: deleteInout,
              disabled: isDeleting.value
            }, [
              (isDeleting.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_95, "삭제하기"))
            ], 8, _hoisted_94)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: deleteAllDialogOpen.value,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((deleteAllDialogOpen).value = $event)),
      "max-width": "450",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[172] || (_cache[172] = [
                  _createTextVNode("mdi-delete-sweep", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[173] || (_cache[173] = _createElementVNode("h3", null, "일괄 삭제 확인", -1)),
            _cache[174] || (_cache[174] = _createElementVNode("p", null, "이 작업은 되돌릴 수 없습니다", -1))
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("p", _hoisted_100, [
              _cache[175] || (_cache[175] = _createTextVNode(" 현재 필터링된 ", -1)),
              _createElementVNode("strong", _hoisted_101, _toDisplayString(filteredInoutList.value.length) + "건", 1),
              _cache[176] || (_cache[176] = _createTextVNode("의 항목을 모두 삭제하시겠습니까? ", -1))
            ]),
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _cache[177] || (_cache[177] = _createElementVNode("span", { class: "label" }, "수입 항목", -1)),
                _createElementVNode("span", _hoisted_104, _toDisplayString(filteredInoutList.value.filter(i => i.hi_gubun === 'IN').length) + "건", 1)
              ]),
              _createElementVNode("div", _hoisted_105, [
                _cache[178] || (_cache[178] = _createElementVNode("span", { class: "label" }, "지출 항목", -1)),
                _createElementVNode("span", _hoisted_106, _toDisplayString(filteredInoutList.value.filter(i => i.hi_gubun === 'OUT').length) + "건", 1)
              ]),
              _createElementVNode("div", _hoisted_107, [
                _cache[179] || (_cache[179] = _createElementVNode("span", { class: "label" }, "총 삭제 금액", -1)),
                _createElementVNode("span", _hoisted_108, _toDisplayString(formatNumber(filteredInoutList.value.reduce((sum, i) => sum + (i.hi_price || 0), 0))) + "원", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_109, [
              _createVNode(_component_v_icon, {
                size: "16",
                color: "#f59e0b"
              }, {
                default: _withCtx(() => [...(_cache[180] || (_cache[180] = [
                  _createTextVNode("mdi-alert-circle", -1)
                ]))]),
                _: 1
              }),
              _cache[181] || (_cache[181] = _createElementVNode("span", null, "삭제 후 복구가 불가능합니다. 신중하게 결정해주세요.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[32] || (_cache[32] = ($event: any) => (deleteAllDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-delete danger",
              onClick: deleteAllItems,
              disabled: isDeleting.value
            }, [
              (isDeleting.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(filteredInoutList.value.length) + "건 모두 삭제", 1))
            ], 8, _hoisted_111)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: learningModalOpen.value,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((learningModalOpen).value = $event)),
      "max-width": "520",
      persistent: ""
    }, {
      default: _withCtx(() => [
        (learningItem.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("div", _hoisted_115, [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    color: "white"
                  }, {
                    default: _withCtx(() => [...(_cache[182] || (_cache[182] = [
                      _createTextVNode("mdi-brain", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_116, [
                  _cache[183] || (_cache[183] = _createElementVNode("h3", null, "AI 추론 결과", -1)),
                  _createElementVNode("p", null, _toDisplayString(learningItem.value.hi_memo) + " · " + _toDisplayString(formatNumber(learningItem.value.hi_price)) + "원", 1)
                ]),
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (learningModalOpen.value = false))
                }, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[184] || (_cache[184] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_117, [
                (parsedNeedCheck.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["inference-status", parsedNeedCheck.value?.reviewReason ? 'need-check' : 'ok'])
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(parsedNeedCheck.value.reviewReason ? 'mdi-alert-circle' : 'mdi-check-circle'), 1)
                        ]),
                        _: 1
                      }),
                      (!parsedNeedCheck.value.reviewReason)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_118, "추론 완료"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_119, "확인 필요 - 아래 내용을 검토해주세요"))
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["result-type", learningItem.value.hi_gubun === 'IN' ? 'income' : 'expense'])
                      }, _toDisplayString(learningItem.value.hi_gubun === 'IN' ? '수입' : '지출'), 3),
                      _cache[185] || (_cache[185] = _createElementVNode("span", { class: "result-label" }, "계정", -1)),
                      (parsedNeedCheck.value?.prediction?.probability)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["confidence-badge", getProbabilityClass(parsedNeedCheck.value.prediction.probability)])
                          }, _toDisplayString(parsedNeedCheck.value.prediction.probability) + "% ", 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _createVNode(_component_v_autocomplete, {
                        modelValue: learningItem.value.hi_scode,
                        "onUpdate:modelValue": [
                          _cache[35] || (_cache[35] = ($event: any) => ((learningItem.value.hi_scode) = $event)),
                          onLearningScodeChange
                        ],
                        items: learningItem.value.hi_gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value,
                        "item-title": "fc_sname",
                        "item-value": "fc_scode",
                        density: "compact",
                        variant: "outlined",
                        "hide-details": "",
                        placeholder: "계정 선택",
                        class: "inline-autocomplete"
                      }, null, 8, ["modelValue", "items"])
                    ])
                  ]),
                  (learningItem.value.hi_gubun === 'OUT')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, [
                          _cache[186] || (_cache[186] = _createElementVNode("span", { class: "result-type income" }, "수입", -1)),
                          _cache[187] || (_cache[187] = _createElementVNode("span", { class: "result-label" }, "상대계정 (자금 출처)", -1)),
                          (learningItem.value.hi_rel_acc && getRelAccPercentage(learningItem.value.hi_rel_acc) > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_126, _toDisplayString(getRelAccPercentage(learningItem.value.hi_rel_acc)) + "% ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_127, [
                          _createVNode(_component_v_autocomplete, {
                            modelValue: learningItem.value.hi_rel_acc,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((learningItem.value.hi_rel_acc) = $event)),
                            items: relAccOptionsWithBalance.value,
                            "item-title": "displayName",
                            "item-value": "scode",
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "",
                            placeholder: "상대계정 선택",
                            class: "inline-autocomplete",
                            clearable: ""
                          }, {
                            item: _withCtx(({ props, item }) => [
                              _createVNode(_component_v_list_item, _mergeProps(props, { title: undefined }), {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_128, [
                                    _createElementVNode("span", _hoisted_129, _toDisplayString(item.raw.sname), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["rel-acc-balance", { 'no-balance': item.raw.availableBalance <= 0 }])
                                    }, _toDisplayString(formatNumber(item.raw.availableBalance)) + "원 ", 3)
                                  ])
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                ((realTimeRelAccDistribution.value.length > 0 || (parsedNeedCheck.value?.prediction?.relAccDistribution?.length ?? 0) > 0) && learningItem.value?.hi_gubun === 'OUT')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      _createElementVNode("h4", null, [
                        _createVNode(_component_v_icon, { size: "16" }, {
                          default: _withCtx(() => [...(_cache[188] || (_cache[188] = [
                            _createTextVNode("mdi-chart-pie", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[189] || (_cache[189] = _createTextVNode(" 이 계정의 상대계정 분포 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_131, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((realTimeRelAccDistribution.value.length > 0 ? realTimeRelAccDistribution.value : parsedNeedCheck.value?.prediction?.relAccDistribution || []), (dist, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: _normalizeClass(["distribution-item", { 'current': learningItem.value?.hi_rel_acc === dist.rel_acc }])
                          }, [
                            _createElementVNode("span", _hoisted_132, _toDisplayString(dist.sname), 1),
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("div", {
                                class: "dist-bar",
                                style: _normalizeStyle({ width: dist.percentage + '%' })
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_134, _toDisplayString(dist.percentage) + "%", 1),
                            _createElementVNode("span", _hoisted_135, "(" + _toDisplayString(dist.count) + "건)", 1)
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (parsedNeedCheck.value?.reviewReason)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                      _createElementVNode("h4", null, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          color: "warning"
                        }, {
                          default: _withCtx(() => [...(_cache[190] || (_cache[190] = [
                            _createTextVNode("mdi-alert-circle-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[191] || (_cache[191] = _createTextVNode(" 확인 필요 이유 ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_137, _toDisplayString(parsedNeedCheck.value.reviewReason), 1),
                      _createElementVNode("p", _hoisted_138, [
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: "warning"
                        }, {
                          default: _withCtx(() => [...(_cache[192] || (_cache[192] = [
                            _createTextVNode("mdi-information", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[193] || (_cache[193] = _createTextVNode(" 계정을 확인/수정 후 \"저장 및 학습\"을 눌러 학습시켜 주세요. ", -1))
                      ])
                    ]))
                  : (parsedNeedCheck.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                        _createElementVNode("h4", null, [
                          _createVNode(_component_v_icon, { size: "16" }, {
                            default: _withCtx(() => [...(_cache[194] || (_cache[194] = [
                              _createTextVNode("mdi-lightbulb-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[195] || (_cache[195] = _createTextVNode(" 추론 근거 ", -1))
                        ]),
                        _createElementVNode("ul", _hoisted_140, [
                          (parsedNeedCheck.value.prediction?.totalCount && parsedNeedCheck.value.prediction.totalCount > 0)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_141, " 과거 유사 거래 " + _toDisplayString(parsedNeedCheck.value.prediction?.totalCount) + "건 분석 ", 1))
                            : _createCommentVNode("", true),
                          (parsedNeedCheck.value.prediction?.relAccReason)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_142, _toDisplayString(getSimplifiedRelAccReason(parsedNeedCheck.value.prediction.relAccReason)), 1))
                            : _createCommentVNode("", true),
                          (parsedNeedCheck.value.reason && !parsedNeedCheck.value.reason.includes('키워드'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_143, _toDisplayString(getSimplifiedReason(parsedNeedCheck.value.reason)), 1))
                            : _createCommentVNode("", true),
                          (!parsedNeedCheck.value.prediction?.totalCount && !parsedNeedCheck.value.prediction?.relAccReason)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_144, " 학습된 데이터가 부족하여 정확도가 낮을 수 있습니다 "))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_145, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-cancel",
                  onClick: _cache[37] || (_cache[37] = ($event: any) => (learningModalOpen.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-save",
                  onClick: checkSimilarAndSave,
                  disabled: isSavingLearning.value
                }, [
                  (isSavingLearning.value)
                    ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                        key: 0,
                        indeterminate: "",
                        size: "18",
                        width: "2",
                        color: "white"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_147, "저장 및 학습"))
                ], 8, _hoisted_146)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: applySimilarConfirmOpen.value,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((applySimilarConfirmOpen).value = $event)),
      "max-width": "480",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_148, [
          _createElementVNode("div", _hoisted_149, [
            _createElementVNode("h3", null, [
              _createVNode(_component_v_icon, { size: "small" }, {
                default: _withCtx(() => [...(_cache[196] || (_cache[196] = [
                  _createTextVNode("mdi-content-copy", -1)
                ]))]),
                _: 1
              }),
              _cache[197] || (_cache[197] = _createTextVNode(" 유사 항목 발견 ", -1))
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[39] || (_cache[39] = ($event: any) => (applySimilarConfirmOpen.value = false))
            }, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[198] || (_cache[198] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_150, [
            _createElementVNode("div", _hoisted_151, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "primary",
                class: "info-icon"
              }, {
                default: _withCtx(() => [...(_cache[199] || (_cache[199] = [
                  _createTextVNode("mdi-file-document-multiple-outline", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("p", _hoisted_152, [
                _cache[200] || (_cache[200] = _createTextVNode(" 적요와 금액이 비슷한 ", -1)),
                _createElementVNode("strong", null, _toDisplayString(similarItemsCount.value) + "개", 1),
                _cache[201] || (_cache[201] = _createTextVNode("의 ", -1)),
                _cache[202] || (_cache[202] = _createElementVNode("br", null, null, -1)),
                _cache[203] || (_cache[203] = _createTextVNode("미분류 항목이 발견되었습니다. ", -1))
              ]),
              _cache[204] || (_cache[204] = _createElementVNode("p", { class: "similar-hint" }, " 같은 계정을 모든 유사 항목에 적용하시겠습니까? ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_153, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-secondary",
              onClick: _cache[40] || (_cache[40] = ($event: any) => (saveLearningData(false)))
            }, " 해당 항목만 저장 "),
            _createElementVNode("button", {
              type: "button",
              class: "btn-primary",
              onClick: _cache[41] || (_cache[41] = ($event: any) => (saveLearningData(true)))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[205] || (_cache[205] = [
                  _createTextVNode("mdi-check-all", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" 모든 유사 항목에 적용 (" + _toDisplayString(similarItemsCount.value) + "건) ", 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: rangeAdjustModalOpen.value,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((rangeAdjustModalOpen).value = $event)),
      "max-width": "450",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_154, [
          _createElementVNode("div", _hoisted_155, [
            _createElementVNode("h3", null, [
              _createVNode(_component_v_icon, { size: "small" }, {
                default: _withCtx(() => [...(_cache[206] || (_cache[206] = [
                  _createTextVNode("mdi-tune", -1)
                ]))]),
                _: 1
              }),
              _cache[207] || (_cache[207] = _createTextVNode(" 금액 범위 조정 ", -1))
            ]),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[43] || (_cache[43] = ($event: any) => (rangeAdjustModalOpen.value = false))
            }, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[208] || (_cache[208] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_156, [
            _createElementVNode("div", _hoisted_157, [
              _createElementVNode("div", _hoisted_158, [
                _cache[209] || (_cache[209] = _createElementVNode("span", { class: "info-label" }, "계정코드:", -1)),
                _createElementVNode("span", _hoisted_159, _toDisplayString(rangeAdjustData.value.scodeName), 1)
              ]),
              _createElementVNode("div", _hoisted_160, [
                _cache[210] || (_cache[210] = _createElementVNode("span", { class: "info-label" }, "관련 키워드:", -1)),
                _createElementVNode("span", _hoisted_161, _toDisplayString(rangeAdjustData.value.keyword), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_162, [
              _createElementVNode("div", _hoisted_163, [
                _cache[212] || (_cache[212] = _createElementVNode("span", { class: "section-title" }, "현재 학습된 범위", -1)),
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("span", null, _toDisplayString(formatNumber(rangeAdjustData.value.currentMin)) + "원", 1),
                  _cache[211] || (_cache[211] = _createElementVNode("span", { class: "range-separator" }, "~", -1)),
                  _createElementVNode("span", null, _toDisplayString(formatNumber(rangeAdjustData.value.currentMax)) + "원", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_165, [
                _cache[220] || (_cache[220] = _createElementVNode("span", { class: "section-title" }, "새로운 범위 설정", -1)),
                _createElementVNode("div", _hoisted_166, [
                  _createElementVNode("div", _hoisted_167, [
                    _cache[213] || (_cache[213] = _createElementVNode("label", null, "최소 금액", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((rangeAdjustData.value.newMin) = $event)),
                      max: rangeAdjustData.value.newMax
                    }, null, 8, _hoisted_168), [
                      [
                        _vModelText,
                        rangeAdjustData.value.newMin,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _cache[215] || (_cache[215] = _createElementVNode("span", { class: "range-separator" }, "~", -1)),
                  _createElementVNode("div", _hoisted_169, [
                    _cache[214] || (_cache[214] = _createElementVNode("label", null, "최대 금액", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((rangeAdjustData.value.newMax) = $event)),
                      min: rangeAdjustData.value.newMin
                    }, null, 8, _hoisted_170), [
                      [
                        _vModelText,
                        rangeAdjustData.value.newMax,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_171, [
                  _createElementVNode("button", {
                    class: "quick-btn",
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (rangeAdjustData.value.newMin = Math.min(rangeAdjustData.value.currentMin, learningItem.value?.hi_price || 0))),
                    title: "현재 입력값을 최소값에 포함"
                  }, [
                    _createVNode(_component_v_icon, { size: "x-small" }, {
                      default: _withCtx(() => [...(_cache[216] || (_cache[216] = [
                        _createTextVNode("mdi-arrow-down", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[217] || (_cache[217] = _createTextVNode(" 입력값 포함 (최소) ", -1))
                  ]),
                  _createElementVNode("button", {
                    class: "quick-btn",
                    onClick: _cache[47] || (_cache[47] = ($event: any) => (rangeAdjustData.value.newMax = Math.max(rangeAdjustData.value.currentMax, learningItem.value?.hi_price || 0))),
                    title: "현재 입력값을 최대값에 포함"
                  }, [
                    _createVNode(_component_v_icon, { size: "x-small" }, {
                      default: _withCtx(() => [...(_cache[218] || (_cache[218] = [
                        _createTextVNode("mdi-arrow-up", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[219] || (_cache[219] = _createTextVNode(" 입력값 포함 (최대) ", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_172, [
              _createVNode(_component_v_icon, {
                size: "small",
                color: "info"
              }, {
                default: _withCtx(() => [...(_cache[221] || (_cache[221] = [
                  _createTextVNode("mdi-information", -1)
                ]))]),
                _: 1
              }),
              _cache[222] || (_cache[222] = _createElementVNode("span", null, "범위를 조정하면 해당 계정코드의 모든 관련 키워드에 적용됩니다.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_173, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[48] || (_cache[48] = ($event: any) => (rangeAdjustModalOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-save",
              onClick: saveRangeAdjust
            }, "범위 저장")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: dictionaryManageModalOpen.value,
      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((dictionaryManageModalOpen).value = $event)),
      "max-width": "1020",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_174, [
          _createElementVNode("div", _hoisted_175, [
            _createElementVNode("div", _hoisted_176, [
              _createVNode(_component_v_icon, {
                size: "24",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[223] || (_cache[223] = [
                  _createTextVNode("mdi-brain", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[225] || (_cache[225] = _createElementVNode("div", { class: "header-text" }, [
              _createElementVNode("h3", null, "AI 학습 관리"),
              _createElementVNode("p", null, "학습 데이터 현황 조회")
            ], -1)),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[50] || (_cache[50] = ($event: any) => (dictionaryManageModalOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[224] || (_cache[224] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_177, [
            (dictionaryStats.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                  _createElementVNode("h4", null, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[226] || (_cache[226] = [
                        _createTextVNode("mdi-chart-bar", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[227] || (_cache[227] = _createTextVNode(" 학습 데이터 현황 ", -1)),
                    _cache[228] || (_cache[228] = _createElementVNode("span", { class: "hint" }, "(카드를 클릭하면 상세 내역을 볼 수 있습니다)", -1))
                  ]),
                  _createElementVNode("div", _hoisted_179, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryStats.value, (stat, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["stat-item clickable", { active: selectedDictTable.value === key }]),
                        key: key,
                        onClick: ($event: any) => (selectDictTable(key as string))
                      }, [
                        _createElementVNode("span", _hoisted_181, _toDisplayString(stat.label), 1),
                        _createElementVNode("span", _hoisted_182, _toDisplayString(formatNumber(stat.count)) + "건", 1),
                        _createVNode(_component_v_icon, {
                          size: "12",
                          class: "expand-icon"
                        }, {
                          default: _withCtx(() => [...(_cache[229] || (_cache[229] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ], 10, _hoisted_180))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (selectedDictTable.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                  _createElementVNode("div", _hoisted_184, [
                    _createElementVNode("h4", null, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[230] || (_cache[230] = [
                          _createTextVNode("mdi-format-list-bulleted", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" " + _toDisplayString(getDictTableLabel(selectedDictTable.value)) + " 상세 ", 1)
                    ]),
                    _createElementVNode("button", {
                      class: "close-detail-btn",
                      onClick: _cache[51] || (_cache[51] = ($event: any) => (selectedDictTable.value = null))
                    }, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[231] || (_cache[231] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  (isDictDetailLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                        _createVNode(_component_v_progress_circular, {
                          indeterminate: "",
                          size: "24",
                          width: "2",
                          color: "primary"
                        }),
                        _cache[232] || (_cache[232] = _createElementVNode("span", null, "데이터 로딩 중...", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (selectedDictTable.value && !isDictDetailLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                        (selectedDictTable.value === 'income' || selectedDictTable.value === 'expense')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                              _createVNode(_component_v_icon, {
                                size: "18",
                                class: "search-icon"
                              }, {
                                default: _withCtx(() => [...(_cache[233] || (_cache[233] = [
                                  _createTextVNode("mdi-magnify", -1)
                                ]))]),
                                _: 1
                              }),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((dictSearchQuery).value = $event)),
                                placeholder: selectedDictTable.value === 'income' ? '수입 계정명 또는 키워드 검색...' : '지출 계정명 또는 키워드 검색...',
                                class: "dict-search-input"
                              }, null, 8, _hoisted_188), [
                                [_vModelText, dictSearchQuery.value]
                              ]),
                              (dictSearchQuery.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "search-clear-btn",
                                    onClick: _cache[53] || (_cache[53] = ($event: any) => (dictSearchQuery.value = ''))
                                  }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                      default: _withCtx(() => [...(_cache[234] || (_cache[234] = [
                                        _createTextVNode("mdi-close", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (selectedDictTable.value === 'scodeRelmap')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_189, [...(_cache[235] || (_cache[235] = [
                                _createElementVNode("strong", null, "지출 계정", -1),
                                _createTextVNode("을 사용할 때 주로 ", -1),
                                _createElementVNode("strong", null, "어떤 수입 계정", -1),
                                _createTextVNode("에서 금액을 차감했는지 기록입니다", -1)
                              ]))]))
                            : (selectedDictTable.value === 'scodeStats')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_190, [...(_cache[236] || (_cache[236] = [
                                  _createTextVNode("각 ", -1),
                                  _createElementVNode("strong", null, "계정별", -1),
                                  _createTextVNode("로 사용된 평균 금액과 횟수 통계입니다", -1)
                                ]))]))
                              : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!isDictDetailLoading.value && (selectedDictTable.value === 'income' || selectedDictTable.value === 'expense'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                        _createElementVNode("div", _hoisted_192, [
                          _createElementVNode("button", {
                            class: "btn-add-item",
                            onClick: openNewAccountDialog
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[237] || (_cache[237] = [
                                _createTextVNode("mdi-plus", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[238] || (_cache[238] = _createTextVNode(" 계정 추가 ", -1))
                          ])
                        ]),
                        (filteredDictGroupedList.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDictGroupedList.value, (group, gIdx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `group-${group.scode}-${gIdx}`,
                                  class: "account-group"
                                }, [
                                  _createElementVNode("div", _hoisted_194, [
                                    _createElementVNode("div", _hoisted_195, [
                                      _createElementVNode("span", _hoisted_196, _toDisplayString(group.scodeName || group.scode || '(계정명 없음)'), 1),
                                      (group.scodeName && group.scode)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_197, "(" + _toDisplayString(group.scode) + ")", 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_198, "총 " + _toDisplayString(group.totalCount || 0) + "회 학습", 1)
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn-add-keyword",
                                      onClick: ($event: any) => (openAddKeywordDialog(group)),
                                      title: "키워드 추가"
                                    }, [
                                      _createVNode(_component_v_icon, { size: "16" }, {
                                        default: _withCtx(() => [...(_cache[239] || (_cache[239] = [
                                          _createTextVNode("mdi-plus", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_199)
                                  ]),
                                  _createElementVNode("div", _hoisted_200, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.keywords, (kw, kIdx) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: `kw-${kw.idx || kIdx}`,
                                        class: "keyword-item",
                                        onClick: ($event: any) => (openEditKeywordDialog(kw, group))
                                      }, [
                                        _createElementVNode("span", _hoisted_202, _toDisplayString(kw.keyword || '(키워드 없음)'), 1),
                                        _createElementVNode("span", _hoisted_203, _toDisplayString(kw.count || 0), 1),
                                        _createElementVNode("button", {
                                          class: "kw-delete",
                                          onClick: _withModifiers(($event: any) => (deleteKeyword(kw)), ["stop"]),
                                          title: "삭제"
                                        }, [
                                          _createVNode(_component_v_icon, { size: "12" }, {
                                            default: _withCtx(() => [...(_cache[240] || (_cache[240] = [
                                              _createTextVNode("mdi-close", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ], 8, _hoisted_204)
                                      ], 8, _hoisted_201))
                                    }), 128))
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (dictGroupedList.value.length > 0 && filteredDictGroupedList.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                _createVNode(_component_v_icon, {
                                  size: "32",
                                  color: "grey-lighten-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[241] || (_cache[241] = [
                                    _createTextVNode("mdi-magnify", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createElementVNode("p", null, "\"" + _toDisplayString(dictSearchQuery.value) + "\" 검색 결과가 없습니다.", 1),
                                _cache[242] || (_cache[242] = _createElementVNode("p", { class: "empty-hint" }, "다른 검색어를 입력해보세요.", -1))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                _createVNode(_component_v_icon, {
                                  size: "32",
                                  color: "grey-lighten-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[243] || (_cache[243] = [
                                    _createTextVNode("mdi-database-off", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[244] || (_cache[244] = _createElementVNode("p", null, "학습된 데이터가 없습니다.", -1)),
                                _cache[245] || (_cache[245] = _createElementVNode("p", { class: "empty-hint" }, "위의 \"계정 추가\" 버튼으로 새로운 계정과 키워드를 등록하세요.", -1))
                              ]))
                      ]))
                    : _createCommentVNode("", true),
                  (!isDictDetailLoading.value && selectedDictTable.value === 'scodeRelmap')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                        _createElementVNode("div", _hoisted_208, [
                          _createElementVNode("button", {
                            class: "btn-add-item",
                            onClick: _cache[54] || (_cache[54] = ($event: any) => (openRelmapDialog('add')))
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[246] || (_cache[246] = [
                                _createTextVNode("mdi-plus", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[247] || (_cache[247] = _createTextVNode(" 매핑 추가 ", -1))
                          ])
                        ]),
                        (dictDetailList.value.length > 0)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_209, [
                              _cache[250] || (_cache[250] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "col-account" }, "지출 계정"),
                                  _createElementVNode("th", { class: "col-relacc" }, "주로 사용하는 수입 계정"),
                                  _createElementVNode("th", { class: "col-count" }, "사용 횟수"),
                                  _createElementVNode("th", { class: "col-action" })
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictDetailList.value, (item, idx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: `rel-${item.idx || idx}`,
                                    class: "clickable-row",
                                    onClick: ($event: any) => (openRelmapDialog('edit', item))
                                  }, [
                                    _createElementVNode("td", _hoisted_211, _toDisplayString(item.scodeName || item.scode), 1),
                                    _createElementVNode("td", _hoisted_212, _toDisplayString(item.relAccName || item.relAcc), 1),
                                    _createElementVNode("td", _hoisted_213, [
                                      _createElementVNode("span", _hoisted_214, _toDisplayString(item.count) + "회", 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_215, [
                                      _createElementVNode("button", {
                                        class: "btn-action btn-edit",
                                        onClick: _withModifiers(($event: any) => (openRelmapDialog('edit', item)), ["stop"]),
                                        title: "수정"
                                      }, [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[248] || (_cache[248] = [
                                            _createTextVNode("mdi-pencil", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_216),
                                      _createElementVNode("button", {
                                        class: "btn-action btn-delete",
                                        onClick: _withModifiers(($event: any) => (deleteDictItem(item)), ["stop"]),
                                        title: "삭제"
                                      }, [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[249] || (_cache[249] = [
                                            _createTextVNode("mdi-delete", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_217)
                                    ])
                                  ], 8, _hoisted_210))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_218, [
                              _createVNode(_component_v_icon, {
                                size: "32",
                                color: "grey-lighten-1"
                              }, {
                                default: _withCtx(() => [...(_cache[251] || (_cache[251] = [
                                  _createTextVNode("mdi-database-off", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[252] || (_cache[252] = _createElementVNode("p", null, "학습된 데이터가 없습니다.", -1))
                            ]))
                      ]))
                    : _createCommentVNode("", true),
                  (!isDictDetailLoading.value && selectedDictTable.value === 'scodeStats')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                        _createElementVNode("div", _hoisted_220, [
                          _createElementVNode("button", {
                            class: "btn-add-item",
                            onClick: _cache[55] || (_cache[55] = ($event: any) => (openStatsDialog('add')))
                          }, [
                            _createVNode(_component_v_icon, { size: "16" }, {
                              default: _withCtx(() => [...(_cache[253] || (_cache[253] = [
                                _createTextVNode("mdi-plus", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[254] || (_cache[254] = _createTextVNode(" 통계 추가 ", -1))
                          ])
                        ]),
                        (dictDetailList.value.length > 0)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_221, [
                              _cache[257] || (_cache[257] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "col-account" }, "계정명"),
                                  _createElementVNode("th", { class: "col-gubun" }, "구분"),
                                  _createElementVNode("th", { class: "col-avg" }, "평균 금액"),
                                  _createElementVNode("th", { class: "col-range" }, "금액 범위"),
                                  _createElementVNode("th", { class: "col-count" }, "사용 횟수"),
                                  _createElementVNode("th", { class: "col-action" })
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictDetailList.value, (item, idx) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: `stat-${item.idx || idx}`,
                                    class: "clickable-row",
                                    onClick: ($event: any) => (openStatsDialog('edit', item))
                                  }, [
                                    _createElementVNode("td", _hoisted_223, _toDisplayString(item.scodeName || item.scode), 1),
                                    _createElementVNode("td", _hoisted_224, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(['gubun-badge', item.gubun === 'IN' ? 'income' : 'expense'])
                                      }, _toDisplayString(item.gubun === 'IN' ? '수입' : '지출'), 3)
                                    ]),
                                    _createElementVNode("td", _hoisted_225, _toDisplayString(formatNumber(item.avgAmount || 0)) + "원", 1),
                                    _createElementVNode("td", _hoisted_226, _toDisplayString(formatNumber(item.minMoney || 0)) + " ~ " + _toDisplayString(formatNumber(item.maxMoney || 0)) + "원", 1),
                                    _createElementVNode("td", _hoisted_227, [
                                      _createElementVNode("span", _hoisted_228, _toDisplayString(item.count) + "회", 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_229, [
                                      _createElementVNode("button", {
                                        class: "btn-action btn-edit",
                                        onClick: _withModifiers(($event: any) => (openStatsDialog('edit', item)), ["stop"]),
                                        title: "수정"
                                      }, [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[255] || (_cache[255] = [
                                            _createTextVNode("mdi-pencil", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_230),
                                      _createElementVNode("button", {
                                        class: "btn-action btn-delete",
                                        onClick: _withModifiers(($event: any) => (deleteDictItem(item)), ["stop"]),
                                        title: "삭제"
                                      }, [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[256] || (_cache[256] = [
                                            _createTextVNode("mdi-delete", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_231)
                                    ])
                                  ], 8, _hoisted_222))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_232, [
                              _createVNode(_component_v_icon, {
                                size: "32",
                                color: "grey-lighten-1"
                              }, {
                                default: _withCtx(() => [...(_cache[258] || (_cache[258] = [
                                  _createTextVNode("mdi-database-off", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[259] || (_cache[259] = _createElementVNode("p", null, "학습된 데이터가 없습니다.", -1))
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_233, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[56] || (_cache[56] = ($event: any) => (dictionaryManageModalOpen.value = false))
            }, " 닫기 ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: keywordDialogOpen.value,
      "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((keywordDialogOpen).value = $event)),
      "max-width": "450",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_234, [
          _createElementVNode("div", _hoisted_235, [
            _createElementVNode("h4", null, _toDisplayString(keywordDialogMode.value === 'add' ? (keywordDialogData.value.isNewAccount ? '계정 및 키워드 추가' : '키워드 추가') : '키워드 수정'), 1),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[58] || (_cache[58] = ($event: any) => (keywordDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[260] || (_cache[260] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_236, [
            _createElementVNode("div", _hoisted_237, [
              _cache[261] || (_cache[261] = _createElementVNode("label", null, "계정", -1)),
              (keywordDialogData.value.isNewAccount)
                ? (_openBlock(), _createBlock(_component_v_autocomplete, {
                    key: 0,
                    modelValue: keywordDialogData.value.scode,
                    "onUpdate:modelValue": [
                      _cache[59] || (_cache[59] = ($event: any) => ((keywordDialogData.value.scode) = $event)),
                      onAccountSelect
                    ],
                    items: selectedDictTable.value === 'income' ? incomeCodeList.value : expenseCodeList.value,
                    "item-title": "fc_sname",
                    "item-value": "fc_scode",
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "",
                    placeholder: "계정 선택"
                  }, null, 8, ["modelValue", "items"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_238, _toDisplayString(keywordDialogData.value.scodeName) + " (" + _toDisplayString(keywordDialogData.value.scode) + ")", 1))
            ]),
            _createElementVNode("div", _hoisted_239, [
              _cache[262] || (_cache[262] = _createElementVNode("label", null, "키워드", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((keywordDialogData.value.keyword) = $event)),
                placeholder: "키워드를 입력하세요 (적요에 포함될 텍스트)",
                onKeyup: _withKeys(saveKeyword, ["enter"])
              }, null, 544), [
                [_vModelText, keywordDialogData.value.keyword]
              ]),
              _cache[263] || (_cache[263] = _createElementVNode("span", { class: "form-hint" }, "입력한 키워드가 적요에 포함되면 해당 계정으로 분류됩니다.", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_240, [
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: _cache[61] || (_cache[61] = ($event: any) => (keywordDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              class: "btn-save",
              onClick: saveKeyword,
              disabled: !keywordDialogData.value.keyword?.trim() || (keywordDialogData.value.isNewAccount && !keywordDialogData.value.scode)
            }, _toDisplayString(keywordDialogMode.value === 'add' ? '추가' : '수정'), 9, _hoisted_241)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: relmapDialogOpen.value,
      "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((relmapDialogOpen).value = $event)),
      "max-width": "450",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_242, [
          _createElementVNode("div", _hoisted_243, [
            _createElementVNode("h4", null, _toDisplayString(relmapDialogMode.value === 'add' ? '상대계정 매핑 추가' : '상대계정 매핑 수정'), 1),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[63] || (_cache[63] = ($event: any) => (relmapDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[264] || (_cache[264] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_244, [
            _createElementVNode("div", _hoisted_245, [
              _cache[265] || (_cache[265] = _createElementVNode("label", null, "지출 계정", -1)),
              _createVNode(_component_v_autocomplete, {
                modelValue: relmapDialogData.value.scode,
                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((relmapDialogData.value.scode) = $event)),
                items: expenseCodeList.value,
                "item-title": "fc_sname",
                "item-value": "fc_scode",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                placeholder: "지출 계정 선택",
                disabled: relmapDialogMode.value === 'edit'
              }, null, 8, ["modelValue", "items", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_246, [
              _cache[266] || (_cache[266] = _createElementVNode("label", null, "상대계정 (수입 계정)", -1)),
              _createVNode(_component_v_autocomplete, {
                modelValue: relmapDialogData.value.relAcc,
                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((relmapDialogData.value.relAcc) = $event)),
                items: incomeCodeList.value,
                "item-title": "fc_sname",
                "item-value": "fc_scode",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                placeholder: "수입 계정 선택"
              }, null, 8, ["modelValue", "items"])
            ]),
            _createElementVNode("div", _hoisted_247, [
              _cache[267] || (_cache[267] = _createElementVNode("label", null, "사용 횟수", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((relmapDialogData.value.count) = $event)),
                min: "1",
                placeholder: "1"
              }, null, 512), [
                [
                  _vModelText,
                  relmapDialogData.value.count,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_248, [
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: _cache[67] || (_cache[67] = ($event: any) => (relmapDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              class: "btn-save",
              onClick: saveRelmap,
              disabled: !relmapDialogData.value.scode || !relmapDialogData.value.relAcc
            }, _toDisplayString(relmapDialogMode.value === 'add' ? '추가' : '수정'), 9, _hoisted_249)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: statsDialogOpen.value,
      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((statsDialogOpen).value = $event)),
      "max-width": "450",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_250, [
          _createElementVNode("div", _hoisted_251, [
            _createElementVNode("h4", null, _toDisplayString(statsDialogMode.value === 'add' ? '계정 통계 추가' : '계정 통계 수정'), 1),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: _cache[69] || (_cache[69] = ($event: any) => (statsDialogOpen.value = false))
            }, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[268] || (_cache[268] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_252, [
            _createElementVNode("div", _hoisted_253, [
              _cache[271] || (_cache[271] = _createElementVNode("label", null, "구분", -1)),
              _createElementVNode("div", _hoisted_254, [
                _createElementVNode("label", {
                  class: _normalizeClass(["gubun-radio", { active: statsDialogData.value.gubun === 'IN' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((statsDialogData.value.gubun) = $event)),
                    value: "IN",
                    disabled: statsDialogMode.value === 'edit'
                  }, null, 8, _hoisted_255), [
                    [_vModelRadio, statsDialogData.value.gubun]
                  ]),
                  _cache[269] || (_cache[269] = _createElementVNode("span", null, "수입", -1))
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass(["gubun-radio", { active: statsDialogData.value.gubun === 'OUT' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((statsDialogData.value.gubun) = $event)),
                    value: "OUT",
                    disabled: statsDialogMode.value === 'edit'
                  }, null, 8, _hoisted_256), [
                    [_vModelRadio, statsDialogData.value.gubun]
                  ]),
                  _cache[270] || (_cache[270] = _createElementVNode("span", null, "지출", -1))
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_257, [
              _cache[272] || (_cache[272] = _createElementVNode("label", null, "계정", -1)),
              _createVNode(_component_v_autocomplete, {
                modelValue: statsDialogData.value.scode,
                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((statsDialogData.value.scode) = $event)),
                items: statsDialogData.value.gubun === 'IN' ? incomeCodeList.value : expenseCodeList.value,
                "item-title": "fc_sname",
                "item-value": "fc_scode",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                placeholder: "계정 선택",
                disabled: statsDialogMode.value === 'edit'
              }, null, 8, ["modelValue", "items", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_258, [
              _createElementVNode("div", _hoisted_259, [
                _cache[273] || (_cache[273] = _createElementVNode("label", null, "최소 금액", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((statsDialogData.value.minMoney) = $event)),
                  min: "0",
                  placeholder: "0"
                }, null, 512), [
                  [
                    _vModelText,
                    statsDialogData.value.minMoney,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_260, [
                _cache[274] || (_cache[274] = _createElementVNode("label", null, "최대 금액", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((statsDialogData.value.maxMoney) = $event)),
                  min: "0",
                  placeholder: "0"
                }, null, 512), [
                  [
                    _vModelText,
                    statsDialogData.value.maxMoney,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_261, [
              _createElementVNode("div", _hoisted_262, [
                _cache[275] || (_cache[275] = _createElementVNode("label", null, "평균 금액", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((statsDialogData.value.avgMoney) = $event)),
                  min: "0",
                  placeholder: "0"
                }, null, 512), [
                  [
                    _vModelText,
                    statsDialogData.value.avgMoney,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_263, [
                _cache[276] || (_cache[276] = _createElementVNode("label", null, "사용 횟수", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((statsDialogData.value.count) = $event)),
                  min: "1",
                  placeholder: "1"
                }, null, 512), [
                  [
                    _vModelText,
                    statsDialogData.value.count,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_264, [
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: _cache[77] || (_cache[77] = ($event: any) => (statsDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              class: "btn-save",
              onClick: saveStats,
              disabled: !statsDialogData.value.scode || !statsDialogData.value.gubun
            }, _toDisplayString(statsDialogMode.value === 'add' ? '추가' : '수정'), 9, _hoisted_265)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: confirmDialogOpen.value,
      "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((confirmDialogOpen).value = $event)),
      "max-width": "520",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_266, [
          _createElementVNode("div", _hoisted_267, [
            _createElementVNode("div", _hoisted_268, [
              _createVNode(_component_v_icon, {
                size: "28",
                color: "white"
              }, {
                default: _withCtx(() => [...(_cache[277] || (_cache[277] = [
                  _createTextVNode("mdi-lock-check", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[278] || (_cache[278] = _createElementVNode("h3", null, "데이터 확정", -1)),
            _cache[279] || (_cache[279] = _createElementVNode("p", null, "확정 후에는 수정/삭제가 불가합니다", -1))
          ]),
          _createElementVNode("div", _hoisted_269, [
            (missingRelAccCount.value > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_270, [
                    _cache[280] || (_cache[280] = _createTextVNode(" 상대계정이 없는 ", -1)),
                    _createElementVNode("strong", _hoisted_271, _toDisplayString(missingRelAccCount.value) + "건", 1),
                    _cache[281] || (_cache[281] = _createTextVNode("을 자동으로 채운 후 확정합니다. ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_272, [
                    _createElementVNode("div", _hoisted_273, [
                      _cache[282] || (_cache[282] = _createElementVNode("span", { class: "label" }, "수입 계정 수", -1)),
                      _createElementVNode("span", _hoisted_274, _toDisplayString(availableIncomeAccounts.value.length) + "개", 1)
                    ]),
                    _createElementVNode("div", _hoisted_275, [
                      _cache[283] || (_cache[283] = _createElementVNode("span", { class: "label" }, "총 수입 잔액", -1)),
                      _createElementVNode("span", _hoisted_276, _toDisplayString(formatNumber(totalAvailableBalance.value)) + "원", 1)
                    ]),
                    _createElementVNode("div", _hoisted_277, [
                      _cache[284] || (_cache[284] = _createElementVNode("span", { class: "label" }, "채울 지출 금액", -1)),
                      _createElementVNode("span", _hoisted_278, _toDisplayString(formatNumber(totalMissingRelAccAmount.value)) + "원", 1)
                    ]),
                    (totalAvailableBalance.value < totalMissingRelAccAmount.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_279, [
                          _cache[285] || (_cache[285] = _createElementVNode("span", {
                            class: "label",
                            style: {"color":"#f59e0b"}
                          }, "⚠️ 잔액 부족", -1)),
                          _createElementVNode("span", _hoisted_280, _toDisplayString(formatNumber(totalMissingRelAccAmount.value - totalAvailableBalance.value)) + "원", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_281, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "#3b82f6"
                    }, {
                      default: _withCtx(() => [...(_cache[286] || (_cache[286] = [
                        _createTextVNode("mdi-information", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[287] || (_cache[287] = _createElementVNode("span", null, "통장에 기록된 순서(등록순)대로 수입 잔액에서 차감합니다.", -1))
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", _hoisted_282, [
                    _cache[288] || (_cache[288] = _createTextVNode(" 총 ", -1)),
                    _createElementVNode("strong", _hoisted_283, _toDisplayString(inoutList.value.length) + "건", 1),
                    _cache[289] || (_cache[289] = _createTextVNode("의 현금출납 데이터를 확정합니다. ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_284, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "#f59e0b"
                    }, {
                      default: _withCtx(() => [...(_cache[290] || (_cache[290] = [
                        _createTextVNode("mdi-alert", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[291] || (_cache[291] = _createElementVNode("span", null, "확정된 데이터는 수정하거나 삭제할 수 없습니다.", -1))
                  ])
                ], 64))
          ]),
          _createElementVNode("div", _hoisted_285, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-cancel",
              onClick: _cache[79] || (_cache[79] = ($event: any) => (confirmDialogOpen.value = false))
            }, "취소"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-delete",
              style: {"background":"linear-gradient(135deg, #059669 0%, #047857 100%)"},
              onClick: executeConfirm,
              disabled: isConfirming.value
            }, [
              (isConfirming.value)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "white"
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_287, [
                    (missingRelAccCount.value > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(missingRelAccCount.value) + "건 채우고 확정", 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("확정하기")
                        ], 64))
                  ]))
            ], 8, _hoisted_286)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})